import React from "react";
import logo from "assets/img/logo/logo_aig_login-2.png";
import {
  Card,
  CardBody,
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Alert,
} from "reactstrap";
import { Textbox, Checkbox, Select as Select1 } from "react-inputs-validation";
import "../../styles/estilos.css";
import Page from "components/Page";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
  consultarCedulaFetch,
  setConsultaPlaca,
  setDatosPersona,
  limpiarDatosCotizacion2,
  coberturasFetch,
  AmparosAdicionalesFetch,
  FetchPorcentajeExtras,
  listarProvinciasComparadorFetch,
  listarParentescosFetch,
  setDatosPersonaAsegurado,
  listarTipoCombustibleFetch,
} from "../../redux/actions/aCotizacion";
import LoadingScreen from "react-loading-screen";
import Select from "react-select";
import makeAnimated from "react-select/lib/animated";
import {
  FetchModificarCarrito,
  FetchGuardarDatosAdiconalesCarrito,
  FetchTotalesCabeceraCotizadores,
} from "../../redux/actions/ACarritoProductos";
import ValoresCotizacion from "./ValoresCotizacion";
import "react-inputs-validation/lib/react-inputs-validation.min.css";
import { ambienteAplicacion, urlListarCiudades, urlValidarChasis, urlValidarMotor } from "../../constants/urls";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { recuperarDatosFacturacionFetch } from "../../redux/actions/aCotizacion";
import { Carousel } from "primereact/carousel";
import { apiGet } from "../../api";
import { infoIds } from "../../constants";
import TablaCoberturasIndividual from "../TablaCoberturasIndividual/TablaCoberturasIndividual";
import styles from "../TablaCoberturasIndividual/styles";
import ValoresCotizacionComparador from "../TablaCoberturasIndividual/ValoresCotizacionComparador";
import NumberFormat from "react-number-format";
import moment from "moment";
import Textarea from "../Generales/TextArea";

class Cotizacion2 extends React.Component {
  constructor(props) {
    super(props);
    const queryParams = new URLSearchParams(props.location && props.location.search);
    const codEspecialInicial = queryParams.get("codigoProductoEspecial");
    const esAigAutoOPracInicial = codEspecialInicial === "comparador" || codEspecialInicial === "pits";

    this.state = {
       mostrarTablaCoberturas: false,
      errorProducto: false,
      mensajeErrorProducto:'',
      tipoDocumento: 1,
      tipoDocumentoAsegurado: 1,
      hasAvaluoError: true,
      fechaEmisionPasaporte: null,
      fechaCaducidadPasaporte: null,
      fechaIngresoPais: null,
      fechaEmisionPasaporteAsegurado: null,
      fechaCaducidadPasaporteAsegurado: null,
      fechaIngresoPaisAsegurado: null,
      planesComparador: this.props.planesComparador,
      placa: this.props.datosCotizacion.datosPlaca.placa,
      planComparadorSeleccionado: null,
      coberturasAdicionalesComparador: [],
      validate: false,
      validateAsegurado: false,
      mismosDatos: true,
      cargarParentescos: false,
      hasPlacaError: true,
      chasis: this.props.datosCotizacion.datosPlaca.chasis,
      motor: this.props.datosCotizacion.datosPlaca.motor,
      cedula: this.props.datosCotizacion.datosPersona.cedula,
      cedulaAsegurado: '',
      nombreAsegurado: '',
      mismosDatosConductor: true,

      //valores extra RUC
      personeria: '',
      correoRuc: '',
      direccion: '',
      hasDireccionFError: true,
      hasCorreoFError: true,


      celular: this.props.datosCotizacion.datosPersona.celular,
      celularAsegurado: '',
      marca: this.props.datosCotizacion.datosPlaca.marca,
      anio: this.props.datosCotizacion.datosPlaca.anio,
      modelo: this.props.datosCotizacion.datosPlaca.modelo,
      clase: this.props.datosCotizacion.datosPlaca.clase,
      tipo: this.props.datosCotizacion.datosPlaca.tipo,
      rastreo: false,
      nombre: this.props.datosCotizacion.datosPersona.nombre,
      fechaNacimiento: this.props.datosCotizacion.datosPersona.fechaNacimiento,
      fechaNacimientoAsegurado: new Date().toString("M/d/yyyy"),
      estadoCivil: this.props.datosCotizacion.datosPersona.codigoEstadoCivil,
      estadoCivilAsegurado: null,
      parentesco: '0',
      genero: this.props.datosCotizacion.datosPersona.codigoGenero,
      generoAsegurado: null,
      territorioSeleccionado: "1",
      territorioSeleccionadoComparador: null,
      territorioSeleccionadoComparadorAsegurado: null,
      ciudadSeleccionada: null,
      ciudades: [],
      formEditado: false,
      valorAsegurado:
        this.props.datosCotizacion.datosPlaca.valor_avaluo === "" ||
          this.props.datosCotizacion.datosPlaca.valor_avaluo === undefined
          ? "18000"
          : this.props.datosCotizacion.datosPlaca.valor_avaluo,
      arrayTerritorios: [],
      arrayTerritoriosComparador: [],
      accesoriosHabilitado: false,
      autoConcesionaria: false,
      selectedOption:
        (this.props.datosCotizacion.datosPlaca.datosAccesorios === undefined ||
          this.props.datosCotizacion.datosPlaca.datosAccesorios.accesorios === undefined)
          ? null
          : this.props.datosCotizacion.datosPlaca.datosAccesorios.accesorios,
      selectedOptionColores:
        this.props.datosCotizacion.datosPlaca.color === ""
          ? null
          : parseInt(this.props.datosCotizacion.datosPlaca.color),
      valorAccesorios: "0",
      arrayAccesorios: [],
      arrayColores: [],
      hasValorAccesoriosError: true,
      cedulaError: "",
      cedulaAseguradoError: "",
      celularError: "",
      hasColorError: false,
      hasMotorError: true,
      hasChasisError: true,
      arrayTipos: [],
      tipoSeleccionado:
        this.props.datosCotizacion.datosPlaca.tipo === ""
          ? undefined
          : this.props.datosCotizacion.datosPlaca.tipo,
      hasTipoError: false,
      contadorCoberturas: 0,
      amparoGastosMedicosCheked: true,
      amparoAccidentesPersonalesCheked: true,
      amparoGastosTransporteCheked:
        this.props.datosCotizacion.datosPlaca
          .amparos &&
          this.props.datosCotizacion.datosPlaca
            .amparos.gastosTransporte
          ? this.props.datosCotizacion.datosPlaca.amparos.gastosTransporte
          : false,
      amparoPatrimonialCheked:
        this.props.datosCotizacion.datosPlaca.amparos &&
          this.props.datosCotizacion.datosPlaca.amparos
            .amparoPatrimonial
          ? this.props.datosCotizacion.datosPlaca.amparos.amparoPatrimonial
          : false,
      amparoObjetosOlvidadosCheked:
        this.props.datosCotizacion.datosPlaca
          .amparos &&
          this.props.datosCotizacion.datosPlaca
            .amparos.objetosOlvidados
          ? this.props.datosCotizacion.datosPlaca.amparos.objetosOlvidados
          : false,
          amparoGastosFunerariosCheked: 
          this.props.datosCotizacion.datosPlaca && 
          this.props.datosCotizacion.datosPlaca.amparos && 
          this.props.datosCotizacion.datosPlaca.amparos.gastosFunerarios
            ? this.props.datosCotizacion.datosPlaca.amparos.gastosFunerarios
            : false,
      amparoAutoSustitutoCheked: true,
      amparoLlaveProtegidaCheked: true,
      amparoDocumentosProtegidosCheked: true,
      capacidad: this.props.datosCotizacion.datosPlaca.capacidad,
      hasCapacidadError: true,
      arrayDeducibles: [],
      deducibleSelected: null,
      arrayDeduciblesTotalDanio: [],
      deducibleTotalDanioSelected: "0%",
      arrayDeduciblesTotalRobo: [],
      deducibleTotalRoboSelected: "0%",
      arrayRc: [],
      rcSelected: null,
      verDeducibles: false,
      verRc: false,
      mostrarMensajeValidarEdad: false,
      mostrarMensajeValidarEdadAsegurado: false,


      codigoProductoEspecial: codEspecialInicial,
      planes: [],
      planSeleccionado: null,
      openModal: false,
      chasisValido: true,
      motorValido: true,
      valorAseguradoValido: true,
      tipoCombustible: (this.props.datosCotizacion.datosPlaca && this.props.datosCotizacion.datosPlaca.tipoCombustible) || "",
      hasTipoCombustibleError: esAigAutoOPracInicial && !(this.props.datosCotizacion.datosPlaca && this.props.datosCotizacion.datosPlaca.tipoCombustible) ? true : false,
    };
    this.validateForm = this.validateForm.bind(this);
    this.planTemplate = this.planTemplate.bind(this);
  }
  
  async componentDidMount() {
    window.scrollTo(0, 0);
    this.props.listarTipoCombustibles();
    const queryParams = new URLSearchParams(this.props.location.search);
    let accion = queryParams.get("accion");
    const placa = queryParams.get("placa");
   

    let codigoProductoEspecial = queryParams.get("codigoProductoEspecial");
    const esAigAutoOPrac = codigoProductoEspecial === "comparador" || codigoProductoEspecial === "pits";
    if (codigoProductoEspecial != null) {
      this.setState({
        codigoProductoEspecial: codigoProductoEspecial,
        hasTipoCombustibleError: esAigAutoOPrac && !this.state.tipoCombustible ? true : false
      });
    } else {
    }

    this.props.limpiarDatosCotizacion();
    const {
      arrayDeducibles,
      deducibleSelected,
      arrayDeduciblesTotalDanio,
      deducibleTotalDanioSelected,
      arrayDeduciblesTotalRobo,
      deducibleTotalRoboSelected,
      arrayRc,
      rcSelected,
      verDeducibles,
      verRc,
    } = this.state;
    if (accion === "editar") {

      this.validarChasis(this.props.datosCotizacion.datosPlaca.chasis)
      this.validarMotor(this.props.datosCotizacion.datosPlaca.motor)

      let arrayProductos = this.props.dataProductoCarrito.productosCarrito
        .carProductos;
      let productoObtenido = arrayProductos.filter(
        (producto) => producto.datosProducto.placa === placa
      );



      const SucursalComparadorSeleccionado = this.props.dataProductoCarrito.productosCarrito.carDatosAsesor ? this.props.dataProductoCarrito.productosCarrito.carDatosAsesor.sucursalSeleccionada : null



      if (this.props.dataProductoCarrito.productosCarrito && this.props.dataProductoCarrito.productosCarrito.carProductos && this.props.dataProductoCarrito.productosCarrito.carProductos[0] && this.props.dataProductoCarrito.productosCarrito.carProductos[0].datosCliente) {

        this.setState(
          {
            tipoDocumento: this.props.dataProductoCarrito.productosCarrito.carProductos[0].datosCliente.tipoDocumento
          }
        )

      }




      if (this.props.dataProductoCarrito.productosCarrito && this.props.dataProductoCarrito.productosCarrito.carProductos && this.props.dataProductoCarrito.productosCarrito.carProductos[0] && this.props.dataProductoCarrito.productosCarrito.carProductos[0].datosCliente) {

        this.setState(
          {
            tipoDocumento: this.props.dataProductoCarrito.productosCarrito.carProductos[0].datosCliente.tipoDocumento,
            fechaEmisionPasaporte: this.props.dataProductoCarrito.productosCarrito.carProductos[0].datosCliente.fechaEmisionPasaporte ? new Date(this.props.dataProductoCarrito.productosCarrito.carProductos[0].datosCliente.fechaEmisionPasaporte) : null,
            fechaCaducidadPasaporte: this.props.dataProductoCarrito.productosCarrito.carProductos[0].datosCliente.fechaCaducidadPasaporte ? new Date(this.props.dataProductoCarrito.productosCarrito.carProductos[0].datosCliente.fechaCaducidadPasaporte) : null,
            fechaIngresoPais: this.props.dataProductoCarrito.productosCarrito.carProductos[0].datosCliente.fechaIngresoPais ? new Date(this.props.dataProductoCarrito.productosCarrito.carProductos[0].datosCliente.fechaIngresoPais) : null
          }
        )

      }

      await this.props.consultarProvincias(
        codigoProductoEspecial === "comparador" || codigoProductoEspecial === "pits" ? codigoProductoEspecial : "vehiculos",
        SucursalComparadorSeleccionado
      )


      productoObtenido = productoObtenido[0];

      if (productoObtenido && productoObtenido.datosAsegurado) {

        const datosAsegurado = productoObtenido.datosAsegurado;



       let tipoDocAsegurado =  this.getTipoDocumentosAsegurado().find(tipo=> tipo.id == datosAsegurado.tipoDocumento)

       let personeria =  this.getPersoneria().find(tipo=> tipo.id == datosAsegurado.personeria)


        this.setState({
          // Datos del Asegurado
          mismosDatos: datosAsegurado.mismosDatos,
          tipoDocumentoAsegurado: tipoDocAsegurado ? tipoDocAsegurado.id : this.getTipoDocumentosAsegurado()[0].id,
          personeria: personeria ? personeria.id : this.getPersoneria()[0].id,
          cedulaAsegurado: datosAsegurado.cedula,
          nombreAsegurado: datosAsegurado.nombre,
          fechaNacimientoAsegurado: datosAsegurado && datosAsegurado.fechaNacimiento ? datosAsegurado.fechaNacimiento : new Date().toString("M/d/yyyy"),
          generoAsegurado: datosAsegurado.codigoGenero,
          estadoCivilAsegurado: datosAsegurado.codigoEstadoCivil,
          celularAsegurado: datosAsegurado.celular,
          territorioSeleccionadoComparadorAsegurado: datosAsegurado.provincia ? datosAsegurado.provincia : null,
    
        });
      
        if (datosAsegurado.provCodigoCore) {
          this.listarCiudades(datosAsegurado.provCodigoCore, datosAsegurado.ciudad ? datosAsegurado.ciudad : null);
        }
      
      
        if (datosAsegurado && datosAsegurado.mismosDatos) {
          await this.props.listarParentescos({ traerParentescoTitular: true });
        } else {
          this.props.listarParentescos({ traerParentescoTitular: false });
        }
      
        console.log('datosAsegurado', datosAsegurado);
      
      } else {
      
        this.setState({
          mismosDatos: true,
        });
      
      }
      

      if (productoObtenido && productoObtenido.datosCliente && productoObtenido.datosCliente.parCodigo) {



        this.setState({
          parentesco: productoObtenido.datosCliente.parCodigo,
        })


      }

      this.setState({
        placa: productoObtenido.datosProducto.placa,
        validate: false,
        hasPlacaError: true,
        chasis: productoObtenido.datosProducto.chasis,
        motor: productoObtenido.datosProducto.motor,
        cedula: productoObtenido.datosCliente.cedula,
        celular: productoObtenido.datosCliente.celular,
        marca: productoObtenido.datosProducto.marca,
        anio: productoObtenido.datosProducto.anio,
        modelo: productoObtenido.datosProducto.modelo,
        clase: productoObtenido.datosProducto.clase,
        tipo: productoObtenido.datosProducto.tipo,
        rastreo: productoObtenido.datosProducto.rastreoSatelital,
        nombre: productoObtenido.datosCliente.nombre,
        fechaNacimiento: productoObtenido.datosCliente.fechaNacimiento,
        estadoCivil: productoObtenido.datosCliente.codigoEstadoCivil,
        genero: productoObtenido.datosCliente.codigoGenero,
        territorioSeleccionado: productoObtenido.datosCliente.codigoTerritorio,
        territorioSeleccionadoComparador: null,
        formEditado: false,
        valorAsegurado: productoObtenido.datosProducto.valorAsegurado,
        arrayTerritorios:
          productoObtenido.datosProducto.datosAccesorios.accesorios,
        arrayTerritoriosComparador:
          this.props.provinciasComparador,
        accesoriosHabilitado:
          parseInt(
            productoObtenido.datosProducto.datosAccesorios.valorAccesorios
          ) > 0
            ? true
            : false,
        selectedOption:
          productoObtenido.datosProducto.datosAccesorios.accesorios,
        selectedOptionColores: productoObtenido.datosProducto.color,
        valorAccesorios:
          productoObtenido.datosProducto.datosAccesorios.valorAccesorios,
        arrayAccesorios: [],
        arrayColores: [],
        hasValorAccesoriosError: true,
        cedulaError: "",
        celularError: "",
        hasColorError: false,
        arrayTipos: productoObtenido.datosProducto.arrayTipos,
        amparoGastosMedicosCheked: true,
        amparoAccidentesPersonalesCheked: true,
        amparoGastosTransporteCheked:
          productoObtenido.datosProducto.amparos.gastosTransporte,
        amparoPatrimonialCheked:
          productoObtenido.datosProducto.amparos.amparoPatrimonial,
        amparoObjetosOlvidadosCheked:
          productoObtenido.datosProducto.amparos.objetosOlvidados,
        amparoGastosFunerariosCheked:
          productoObtenido.datosProducto.amparos.gastosFunerarios,
        amparoAutoSustitutoCheked: true,
        amparoLlaveProtegidaCheked: true,
        amparoDocumentosProtegidosCheked: true,
        capacidad: productoObtenido.datosProducto.capacidad,
        tipoCombustible: productoObtenido.datosProducto.tipoCombustible || "",
        hasTipoCombustibleError: esAigAutoOPrac && !productoObtenido.datosProducto.tipoCombustible ? true : false,
      });

      this.props.setDatosPlaca(productoObtenido.datosProducto);
      this.props.setDatosPersona(productoObtenido.datosCliente);

      this.props.listarCoberturas(
        productoObtenido.datosCliente.codigoTerritorio
      );
      //Listar los Amparos Adicionales por default
      const codEspecial = new URLSearchParams(this.props.location.search).get("codigoProductoEspecial")
      this.props.listarAmparosAdicionales(
        productoObtenido.datosCliente.codigoTerritorio,
        codEspecial
      );
      this.props.setPorcentajeExtras(
        productoObtenido.datosCliente.codigoTerritorio,
        codEspecial == 'comparador' || 'pits' ? true : false
      );
    }
    //Obtener Producto cuando no es edicion para obtener Deducibles
    let placacotizada = this.props.datosCotizacion.datosPlaca.placa;
    let arrayProductos1 = this.props.dataProductoCarrito.productosCarrito
      .carProductos;
    let productoObtenido1 = arrayProductos1.filter(
      (producto) => producto.datosProducto.placa === placacotizada
    );




    productoObtenido1 = productoObtenido1[0];
    this.props.setDatosPlaca(productoObtenido1.datosProducto); //Actualizar la informacion de la placa
    //cargar el valor de capacidad
    this.setState({ capacidad: productoObtenido1.datosProducto.capacidad });
    //cargar array de deducibles
    if (
      this.props.deduciblesRolesDatos !== undefined &&
      this.props.deduciblesRolesDatos.deduciblesRoles
    ) {
      // Cargar deducibles parcial por daños
      if (this.props.deduciblesRolesDatos.deduciblesRoles.deducibles) {
        this.props.deduciblesRolesDatos.deduciblesRoles.deducibles.forEach((element) => {
          const elemento = { id: element.valor, name: element.valor };
          arrayDeducibles.push(elemento);
        });
      }
      
      // Cargar deducibles total por daños
      if (this.props.deduciblesRolesDatos.deduciblesRoles.deduciblesTotalDanio) {
        this.props.deduciblesRolesDatos.deduciblesRoles.deduciblesTotalDanio.forEach((element) => {
          const elemento = { id: element.valor, name: element.valor };
          arrayDeduciblesTotalDanio.push(elemento);
        });
      }
      
      // Cargar deducibles total por robo
      if (this.props.deduciblesRolesDatos.deduciblesRoles.deduciblesTotalRobo) {
        this.props.deduciblesRolesDatos.deduciblesRoles.deduciblesTotalRobo.forEach((element) => {
          const elemento = { id: element.valor, name: element.valor };
          arrayDeduciblesTotalRobo.push(elemento);
        });
      }
    }



    if (this.props.planesComparador.length == 0 && (this.state.codigoProductoEspecial == 'comparador' || this.state.codigoProductoEspecial == 'pits')) {
      this.setState({ formEditado: true })
      this.onClick(productoObtenido1)
    }
    if (
      productoObtenido1 !== null &&
      productoObtenido1.datosCalculoScoring.deducible
    ) {
      this.setState({
        deducibleSelected: productoObtenido1.datosCalculoScoring.deducible,
        deducibleTotalDanioSelected: productoObtenido1.datosCalculoScoring.porcentajeDeducibleOdTotalDanio ? productoObtenido1.datosCalculoScoring.porcentajeDeducibleOdTotalDanio : "0%",
        deducibleTotalRoboSelected: productoObtenido1.datosCalculoScoring.porcentajeDeducibleTotalTheftRobo ? productoObtenido1.datosCalculoScoring.porcentajeDeducibleTotalTheftRobo : "0%",
      });
    }
    if (
      this.props.deduciblesRolesDatos !== undefined &&
      this.props.deduciblesRolesDatos.deduciblesRoles.responsabilidadCivil
    ) {
      //Crear array de responsabilidad civil
      this.props.deduciblesRolesDatos.deduciblesRoles.responsabilidadCivil.forEach(
        (element) => {
          const elemento = {
            id: element.valor,
            name: element.valor,
          };
          arrayRc.push(elemento);
        }
      );
    }
    if (
      productoObtenido1 !== null &&
      productoObtenido1.datosCalculoScoring.limiteRC
    ) {
      this.setState({
        rcSelected: productoObtenido1.datosCalculoScoring.limiteRC,
      });
    }
    // ----Fin deducibles y responsabilidad civil
    //verificar permisos de deducible para roles
    if (
      this.props.deduciblesRolesDatos !== undefined &&
      this.props.deduciblesRolesDatos.deduciblesRoles.permisos
    ) {
      if (
        this.props.datosUsuarios !== undefined &&
        this.props.datosUsuarios.usu_tipo_usuario
      ) {
        let permisoUsuarioObtenido = this.props.deduciblesRolesDatos.deduciblesRoles.permisos.filter(
          (permiso) =>
            permiso.tipoUsuario === this.props.datosUsuarios.usu_tipo_usuario
        );
        permisoUsuarioObtenido = permisoUsuarioObtenido[0];
        if (
          permisoUsuarioObtenido !== undefined &&
          permisoUsuarioObtenido.puedeCambiarDeducible &&
          permisoUsuarioObtenido.puedeCambiarDeducible === "true"
        ) {
          this.setState({
            verDeducibles: true,
          });
        } else {
          /* this.setState({
            deducibleSelected: null,
          }); */
        }
        if (
          permisoUsuarioObtenido !== undefined &&
          permisoUsuarioObtenido.puedeCambiarResponsabilidadCivil &&
          permisoUsuarioObtenido.puedeCambiarResponsabilidadCivil === "true"
        ) {
          this.setState({
            verRc: true,
          });
        } else {
          /*  this.setState({
             rcSelected: null,
           }); */
        }
      }
    }
    //-----Fin verificar permisos de deducible para roles
    //Obtener el porcentaje extra de
    const codEspecial = new URLSearchParams(this.props.location.search).get("codigoProductoEspecial")
    this.props.setPorcentajeExtras(
      this.props.catalogoCotizacion.territorioDefault,
      codEspecial == 'comparador' || 'pits' ? true : false
    );

    //Listar las coberturas por default
    this.props.listarCoberturas(
      this.props.catalogoCotizacion.territorioDefault
    );
    //Listar los Amparos Adicionales por default
    this.props.listarAmparosAdicionales(
      this.props.catalogoCotizacion.territorioDefault,
      codEspecial
    );
    /*
        let arrayTerritorios = [
          {
            id: 1,
            name: "Cuenca y Austro"
          }
        ];*/

    let arrayTerritorios = this.state.arrayTerritorios.slice();
    var arrayTerritoriosComparador = this.state.arrayTerritoriosComparador.slice();


    this.props.catalogoCotizacion.territorios.forEach((element) => {
      const elemento = {
        id: element.ciuCodigoCore,
        name: element.ciuNombre,
        provCodigoCore: element.provCodigoCore,
        paiCodigoCore: element.paiCodigoCore,
      };
      arrayTerritorios.push(elemento);
    });

    arrayTerritoriosComparador = []


    this.props.provinciasComparador.forEach((element) => {
      const elemento = {
        id: element.provCodigoCore,
        value: element.provCodigoCore,
        name: element.label,
        label: element.label,
        provCodigoCore: element.provCodigoCore,
        //paiCodigoCore: element.paiCodigoCore,
      };
      arrayTerritoriosComparador.push(elemento);





    });
    var territorioDefault = arrayTerritoriosComparador.find(v => v.id == this.props.datosCotizacion.datosPersona.codigoTerritorio)
    if (this.props.datosCotizacion && this.props.datosCotizacion.datosPersona && this.props.datosCotizacion.datosPersona.codigoTerritorio && accion === "editar") {
      territorioDefault = arrayTerritoriosComparador.find(v => v.id == this.props.datosCotizacion.datosPersona.codigoTerritorio)

    }
    if (territorioDefault && accion != "editar") {
      console.log('territorioDefault', territorioDefault)
      this.listarCiudades(territorioDefault.provCodigoCore, null)
      this.setState({
        territorioSeleccionadoComparadorAsegurado: territorioDefault
      })
      
    }

    if (territorioDefault) {
      this.setState({
        territorioSeleccionadoComparador: territorioDefault
      })
    }

    const tipoCombustibleGuardado = (productoObtenido1 && productoObtenido1.datosProducto && productoObtenido1.datosProducto.tipoCombustible)
      || (this.props.datosCotizacion.datosPlaca && this.props.datosCotizacion.datosPlaca.tipoCombustible)
      || "";
    this.setState({
      tipoCombustible: tipoCombustibleGuardado,
      hasTipoCombustibleError: esAigAutoOPrac && !tipoCombustibleGuardado ? true : false,
    });

    this.setState({ arrayTerritorios: arrayTerritorios });
    this.setState({ arrayTerritoriosComparador: arrayTerritoriosComparador });

    //----
    let arrayTipos = this.state.arrayTipos.slice();
    this.props.datosCotizacion.datosPlaca.arrayTipos.forEach((element) => {
      const elemento = {
        id: element.id,
        name: element.name,
      };
      arrayTipos.push(elemento);
    });
    this.setState({ arrayTipos: arrayTipos });

    //--
    let arrayAccesorios = this.state.arrayAccesorios.slice();

    this.props.catalogoCotizacion.accesorios.forEach((element) => {
      const elemento = {
        value: element.accCodigoCore,
        label: element.accNombre,
      };
      arrayAccesorios.push(elemento);
    });
    this.setState({ arrayAccesorios: arrayAccesorios });

    let arrayColores = this.state.arrayColores.slice();

    this.props.catalogoCotizacion.colores.forEach((element) => {
      const elemento = {
        value: element.colCodigoCore,
        label: element.colNombre,
      };
      arrayColores.push(elemento);
    });
    this.setState({ arrayColores: arrayColores });

    //Agregado para mostrar los totales en la cabecera
    let datosJSON = {
      empresa: "AIGMETROPOLITANA",
      plataforma: "WEB",
      idCarrito: this.props.dataProductoCarrito.productosCarrito.idCarrito,
    };
    await this.props.datosFacturacion(datosJSON);
    //Cargar Totales de la cabecera
    if (
      this.props.dataFacturacion !== undefined &&
      this.props.dataFacturacion !== ""
    ) {
      let param = {
        pathIcono: this.props.dataFacturacion.pathIconoTotalesCabecera
          ? this.props.dataFacturacion.pathIconoTotalesCabecera
          : "",
        totalItems: this.props.dataFacturacion.numItemsCarrito
          ? this.props.dataFacturacion.numItemsCarrito
          : "0",
        totalPrima:
          this.props.dataFacturacion.carValoresTotales &&
            this.props.dataFacturacion.carValoresTotales.primaTotal
            ? this.props.dataFacturacion.carValoresTotales.primaTotal
            : "0.00",
        ramoCotizador: this.props.dataFacturacion.carDescripcionRamo
          ? this.props.dataFacturacion.carDescripcionRamo
          : "",
      };
      await this.props.actualizarTotalesCabecera(param);
    }

    /*this.props.catalogoCotizacion.accesorios.forEach(element => {
      const elemento={
        value:element.accCodigoCore,
        label:element.accNombre
      }
      arrayAccesorios.push(elemento)
      
    });
    this.setState({arrayAccesorios:arrayAccesorios})*/

    /*
        let error=false;
    

    
        let datosPlaca = this.props.datosCotizacion.datosPlaca;
        
    
        if(this.state.accesoriosHabilitado){
    
          if(this.state.selectedOption===null || this.state.selectedOption.length===0){
            error=true;
          }
          else{
            const datosAccesorios={
              accesorios:this.state.selectedOption,
              valorAccesorios:this.state.valorAccesorios
            }
            datosPlaca.datosAccesorios=datosAccesorios;
          }
    
        }
        else
        {
          
          const datosAccesorios={
            accesorios:[],
            valorAccesorios:0
          }
          datosPlaca.datosAccesorios=datosAccesorios;
        }
    
        console.log("formulario continuar des accesorios ",this.state.accesoriosHabilitado)
    
        if(!error ){
          delete datosPlaca.arrayMarcas;
          delete datosPlaca.marcaSeleccionada;
          delete datosPlaca.arrayModelos;
          delete datosPlaca.modeloSeleccionado;
          datosPlaca.anio=this.state.anio;
          datosPlaca.chasis=this.state.chasis;
          datosPlaca.rastreoSatelital=this.state.rastreo;
          datosPlaca.valorAsegurado = this.state.valorAsegurado;
    
    
          this.props.setDatosPlaca(datosPlaca);
    
    
    
          let datosPersona = this.props.datosCotizacion.datosPersona;
          datosPersona.codigoTerritorio=this.state.territorioSeleccionado
          this.props.setDatosPersona(datosPersona);
    
          const datosCarrito={
            empresa:"AIGMETROPOLITANA",
            plataforma:"WEB",
            cliCodigoCore:"",
            datosProducto:datosPlaca,
            datosCliente:this.props.datosCotizacion.datosPersona,
            datosCoberturas:[],
            datosAmparos:[],
            placa:datosPlaca.placa,
            accion:"agregar"
          }
    
          const datosCarritoJSON=JSON.stringify(datosCarrito);
          console.log("Enviar carrtio ",datosCarritoJSON)
    
          this.props.modificarCarrito(datosCarrito);
    
        }*/

    console.log("BeforeProps", this.props.productosCarrito);
    this.obtenerPlanesKmPaquete();

    if (this.state.codigoProductoEspecial == "comparador" || this.state.codigoProductoEspecial == "pits") {
      this.obtenerPlanComparador(productoObtenido1)
    }

    this.onClick(productoObtenido1, true)


    setTimeout(() => {
      this.setState({ mostrarTablaCoberturas: true });
    }, 1000);
 
  }


  /**
   * Función para validar chasis
   * chasis ingresado por el usuario
   *  */
  validarChasis = async (chasis) => {

    const { datosCotizacion, } = this.props;

    if (chasis == '' && datosCotizacion.datosPlaca.placa === "") {
      return this.setState({
        chasisValido: true
      })
    }

    if (this.state.placa === "" && (chasis == '' || !chasis)) {

      console.log('vervalidai', chasis, this.state.placa)
      this.setState({
        chasisValido: true
      })
    } else {
      var url = urlValidarChasis + chasis;
      const response = await fetch(url)
      const json = await response.json()

      if (json.transaccion) {

        this.setState({
          chasisValido: true
        })

      } else {
        this.setState({
          chasisValido: false
        })

      }
    }
  }

  /**
  * Función para validar motor
  * motor ingresado por el usuario
  *  */
  validarMotor = async (motor) => {

    const { datosCotizacion, } = this.props;

    if (motor == '' && datosCotizacion.datosPlaca.placa === "") {
      return this.setState({
        motorValido: true
      })
    }

    console.log('validacionMotor', motor)

    if ((this.state.placa === "") && motor == '') {


      this.setState({
        motorValido: true
      })
    } else {
      var url = urlValidarMotor + motor;
      const response = await fetch(url)
      const json = await response.json()

      if (json.transaccion) {

        this.setState({
          motorValido: true
        })

      } else {
        this.setState({
          motorValido: false
        })

      }
    }

  }

  obtenerPlanesKmPaquete = () => {
    let selectedplan = null;
    const arrayProductos = this.props.dataProductoCarrito.productosCarrito
      .carProductos;
    //console.log("productos", arrayProductos[0]);
    //var PlanesKmPaquete = null;
    var PlanesKmPaquete = arrayProductos[0].PlanesKmPaquete;
    if (PlanesKmPaquete !== undefined && PlanesKmPaquete !== null && PlanesKmPaquete !== '' && PlanesKmPaquete.length > 0) {
      const plan = arrayProductos[0].datosCalculoScoring.plan;
      PlanesKmPaquete = PlanesKmPaquete.slice(2, PlanesKmPaquete.length);//se pone para no mostrar en prod los 2 primeros productos
      this.setState({ planes: PlanesKmPaquete });
      console.log("plan", plan);
      PlanesKmPaquete.forEach((item) => {
        if (plan === item.plan) {
          selectedplan = item;
        }
      });
    }
    if (selectedplan) {
      this.setState({ planSeleccionado: selectedplan });
    }

  };


  obtenerPlanComparador = (productoActual) => {


    if (productoActual && productoActual.datosCalculoScoring && productoActual.datosCalculoScoring.plan) {
      const planEncontrado = this.props.planesComparador.find(plan => plan.codigo == productoActual.datosCalculoScoring.plan)

      this.setState({ planComparadorSeleccionado: planEncontrado });
    }

  };


  openModal = (value) => {
    this.setState({ openModal: value });
  };
  handleChange = (selectedOption) => {
    this.setState({ selectedOption });

    //console.log(`Option selected:`, selectedOption);
  };

  listarCiudades = async (provCodigoCore, ciudadPrecargada) => {



    this.setState({
      ciudades: [],
      ciudadSeleccionada: null
    })

    await fetch(`${urlListarCiudades}${provCodigoCore}`)
      .then((response) => response.json())
      .then((data) => {
        //console.log(data);
        if (data.transaccion) {
          let ciudades = data.ciudades;

          let arrayCiudades = [];
          let arrayCiudadesSelect = [];
          if (ciudades.length > 1)
            arrayCiudades.push({ id: "", name: "Seleccione la ciudad" });
          arrayCiudadesSelect.push({ id: "", name: "Seleccione la ciudad" });
          ciudades.forEach((element) => {
            const elemento = {
              id: element.ciuCodigoCore,
              name: element.ciuNombre,
              provCodigoCore: element.provCodigoCore,
            };
            arrayCiudades.push(elemento);

            const elemento2 = {
              value: element.ciuCodigoCore,
              label: element.ciuNombre,
              provCodigoCore: element.provCodigoCore,
            };
            arrayCiudadesSelect.push(elemento2);
          });

          var ciudadSeleccionada = null


          if (ciudadPrecargada) {
            ciudadSeleccionada = ciudadPrecargada
          } else {
            var ciudadEncontrada = arrayCiudadesSelect.find(ciudad => ciudad.value == data.ciudadDefecto)
            ciudadSeleccionada = ciudadEncontrada ? ciudadEncontrada : null
          }




          this.setState({
            ciudades: arrayCiudadesSelect,
            ciudadSeleccionada: ciudadSeleccionada
          })

          console.log('ciudades', ciudadSeleccionada)


        } else {

        }
      })

      .catch((response) => {

      });
  };


  handleChangeColores = (selectedOptionColores) => {
    this.setState({ selectedOptionColores });
    this.setState({ hasColorError: false });
    this.setState({ formEditado: true });

    //console.log(`Option selected colores:`, selectedOptionColores);
  };

  async cambiarValores(cedula) {
    await this.props.consultarCedula(cedula, false, false);
    if (this.props.datosCotizacion.consultarCedulaHasError) {
      this.setState({
        cedulaError: cedula,
      });
      this.setState({
        cedula: cedula,
        nombre: "",
        celular: "",
        formEditado: true,
      });
    } else {
      this.setState({
        nombre: this.props.datosCotizacion.datosPersona.nombre,
        celular: this.props.datosCotizacion.datosPersona.celular,
        fechaNacimiento: this.props.datosCotizacion.datosPersona
          .fechaNacimiento,
        estadoCivil: this.props.datosCotizacion.datosPersona.codigoEstadoCivil,

        genero: this.props.datosCotizacion.datosPersona.codigoGenero,
        formEditado: true,
      });

      if (this.state.mismosDatos) {
        this.setState({
          nombreAsegurado: this.props.datosCotizacion.datosPersona.nombre,
          celularAsegurado: this.props.datosCotizacion.datosPersonaAsegurado.celularAsegurado,
          fechaNacimientoAsegurado: this.props.datosCotizacion.datosPersona
            .fechaNacimiento,
          estadoCivilAsegurado: this.props.datosCotizacion.datosPersona.codigoEstadoCivil,

          generoAsegurado: this.props.datosCotizacion.datosPersonaAsegurado.codigoGeneroAsegurado,
        });
      }
    
    }
  }

  async cambiarValoresAsegurado(cedula) {

    await this.props.consultarCedula(cedula, true , false);
    if (this.props.datosCotizacion.consultarCedulaHasError) {
      this.setState({
        cedulaAseguradoError: cedula,
      });
      this.setState({
        cedulaAsegurado:cedula,
        nombreAsegurado: "",
        //  nombre: "",
        celularAsegurado: "",
        formEditado: true,
      });
    } else {
      this.setState({
        nombreAsegurado: this.props.datosCotizacion.datosPersonaAsegurado.nombreAsegurado,
        celularAsegurado: this.props.datosCotizacion.datosPersonaAsegurado.celularAsegurado,
        fechaNacimientoAsegurado: this.props.datosCotizacion.datosPersonaAsegurado
          .fechaNacimientoAsegurado,
        estadoCivilAsegurado: this.props.datosCotizacion.datosPersonaAsegurado.codigoEstadoCivilAsegurado,

        generoAsegurado: this.props.datosCotizacion.datosPersonaAsegurado.codigoGeneroAsegurado,
        formEditado: true,
      });
    }
  }

 



  toggleValidating(validate) {
    this.setState({ validate });
  }
  validateForm(e) {
    e.preventDefault();
    this.toggleValidating(true);
    const {
      hasContraseniaActualError,
      hasContraseniaNuevaError,
      hasConfirmacionError,
    } = this.state;

    if (
      !hasContraseniaActualError ||
      !hasContraseniaNuevaError ||
      !hasConfirmacionError
    ) {
      this.handleOnClick();
    }
  }

  getTipoDocumentos() {
    const listadoTipoDocumentos = [
      { id: infoIds.codigoCedulaNum, name: "Cédula", personeria: 1 },
      //   { id: infoIds.codigoPasaporteNum, name: "Pasaporte", personeria: 1 },
      //{ id: 3, name: "Ruc", personeria: 1 }, //agregado para pruebas
    ];

    return listadoTipoDocumentos;
  }

  getTipoDocumentosAsegurado() {
    const listadoTipoDocumentos = [
      { id: infoIds.codigoCedulaNum, name: "Cédula", personeria: 1, nameNombre: 'Nombres', nameFecha: 'Fecha de nacimiento' },
      { id: infoIds.codigoRucNum, name: "Ruc", personeria: 1, nameNombre: 'Razón Social', nameFecha: 'Fecha de constitución' }, //agregado para pruebas
      { id: infoIds.codigoPasaporteNum, name: "Pasaporte", personeria: 1, nameNombre: 'Nombres', nameFecha: 'Fecha de nacimiento' },

    ];

    return listadoTipoDocumentos;
  }


  getPersoneria(){
    return [
      { id: 0, name: "Seleccione la personería" },
      { id: 1, name: "Natural" },
      { id: 2, name: "Jurídica" },
    ]
  }

  onClick = async (productoObtenido10, inicial) => {


    if (!this.state.valorAseguradoValido) {
      return false
    }

    if(!mismosDatos && this.state.mostrarMensajeValidarEdadAsegurado){
      return false
    }

    const codEspecial = new URLSearchParams(this.props.location.search).get("codigoProductoEspecial")

    await this.toggleValidating(true);
    this.setState({
      validateAsegurado: true
    })


    this.setState({
      validateAsegurado: true
    })

    const {
      validate,
      placa,
      chasis,
      motor,
      cedula,
      cedulaError,
      celular,
      celularError,
      marca,
      anio,
      modelo,
      tipo,
      rastreo,
      nombre,
      fechaNacimiento,
      fechaNacimientoAsegurado,
      estadoCivil,
      estadoCivilAsegurado,
      parentesco,
      genero,
      territorioSeleccionado,
      territorioSeleccionadoComparador,
      formEditado,
      valorAsegurado,
      tipoSeleccionado,
      accesoriosHabilitado,
      autoConcesionaria,
      selectedOption,
      selectedOptionColores,
      valorAccesorios,
      hasValorAccesoriosError,
      amparoGastosMedicosCheked,
      amparoAccidentesPersonalesCheked,
      amparoGastosTransporteCheked,
      amparoPatrimonialCheked,
      amparoObjetosOlvidadosCheked,
      amparoGastosFunerariosCheked,
      amparoAutoSustitutoCheked,
      amparoLlaveProtegidaCheked,
      amparoDocumentosProtegidosCheked,
      capacidad,
      deducibleSelected,
      deducibleTotalDanioSelected,
      deducibleTotalRoboSelected,
      rcSelected,
      mismosDatos,
      cedulaAsegurado,
      tipoDocumentoAsegurado,
      celularAsegurado,
      nombreAsegurado,
      generoAsegurado,
      validateAsegurado,
      personeria
    } = this.state;





    if (!mismosDatos) {
      if (
        !cedulaAsegurado || cedulaAsegurado.trim() == '' ||
        !estadoCivilAsegurado || estadoCivilAsegurado == '' ||
        !nombreAsegurado || nombreAsegurado.trim() == '' ||
        !tipoDocumentoAsegurado || tipoDocumentoAsegurado == '' ||
        !generoAsegurado || generoAsegurado == '' ||
         parentesco == ''   

      ) {
       
        return false
      } else if (
        tipoDocumentoAsegurado == '1' &&
        cedulaAsegurado.length != 10

      ) {
        console.log('bandera2')
        return false

      } else if (
 
        tipoDocumentoAsegurado == '2' &&
        cedulaAsegurado.length != 13

      ) {
        console.log('bandera3')
        return false

      }

      
    }


    let error = false;
    if (!formEditado  && !inicial) {
         let datosPlaca = this.props.datosCotizacion.datosPlaca;

      datosPlaca.autoConcesionaria = autoConcesionaria

      if (accesoriosHabilitado) {
        if (selectedOption === null || selectedOption.length === 0) {
          error = true;
        } else {
          let valorExtras =
            (valorAsegurado * this.props.datosCotizacion.porcentajeExtras) /
            100;
          if (valorAccesorios === "" || valorAccesorios < 0) {
            error = true;
          } else if (valorAccesorios <= valorExtras) {
            const datosAccesorios = {
              accesorios: selectedOption,
              valorAccesorios: valorAccesorios,
            };
            datosPlaca.datosAccesorios = datosAccesorios;
          } else {
            error = true;
          }
        }
      } else {
        const datosAccesorios = {
          accesorios: [],
          valorAccesorios: 0,
        };
        datosPlaca.datosAccesorios = datosAccesorios;
      }

      if (
        (
          this.state.codigoProductoEspecial == "comparador" ||
          this.state.codigoProductoEspecial == "pits" ||
          this.state.codigoProductoEspecial == "vehiculosKilometrosPaquete"
        ) &&
        (
          !celular ||
          celular.trim() == "" ||
          celular.length < 7 ||
          celular.length > 10
        )
      ) {
        error = true
      }

      if ((parseInt(this.state.tipoDocumento) == 3) && (this.state.fechaEmisionPasaporte == null || this.state.fechaCaducidadPasaporte == null || this.state.fechaIngresoPais == null)) {
        error = true
      }    datosPlaca = this.props.datosCotizacion.datosPlaca;

      datosPlaca.autoConcesionaria = autoConcesionaria

      if (accesoriosHabilitado) {
        if (selectedOption === null || selectedOption.length === 0) {
          error = true;
        } else {
          let valorExtras =
            (valorAsegurado * this.props.datosCotizacion.porcentajeExtras) /
            100;
          if (valorAccesorios === "" || valorAccesorios < 0) {
            error = true;
          } else if (valorAccesorios <= valorExtras) {
            const datosAccesorios = {
              accesorios: selectedOption,
              valorAccesorios: valorAccesorios,
            };
            datosPlaca.datosAccesorios = datosAccesorios;
          } else {
            error = true;
          }
        }
      } else {
        const datosAccesorios = {
          accesorios: [],
          valorAccesorios: 0,
        };
        datosPlaca.datosAccesorios = datosAccesorios;
      }

      if (
        (
          this.state.codigoProductoEspecial == "comparador" ||
          this.state.codigoProductoEspecial == "pits" ||
          this.state.codigoProductoEspecial == "vehiculosKilometrosPaquete"
        ) &&
        (
          !celular ||
          celular.trim() == "" ||
          celular.length < 7 ||
          celular.length > 10
        )
      ) {
        error = true
      }

      if ((parseInt(this.state.tipoDocumento) == 3) && (this.state.fechaEmisionPasaporte == null || this.state.fechaCaducidadPasaporte == null || this.state.fechaIngresoPais == null)) {
        error = true
      }
      if (error) {
        return false
      } 
      if (!selectedOptionColores) {
        this.setState({ hasColorError: true });
      }
      if (
        selectedOptionColores !== undefined &&
        selectedOptionColores &&
        // validar limites motor y chasis

        this.state.motorValido &&
        this.state.chasisValido &&
        !this.state.hasTipoCombustibleError &&
        capacidad !== "" &&
        tipoSeleccionado != "" &&
        tipoSeleccionado != undefined &&
        valorAsegurado !== "" &&
        (codEspecial != 'vehiculosKilometrosPaquete' || codEspecial == 'vehiculosKilometrosPaquete' && this.state.planSeleccionado)
      ) {
        let color = selectedOptionColores;
        if (typeof selectedOptionColores === "object") {
          color = selectedOptionColores.value.toString();
        }
        /*let valtipo=this.props.datosCotizacion.datosPlaca.tipo;
        if(this.props.datosCotizacion.datosPlaca.tipo === "")
        {*/
        let valtipo = tipoSeleccionado;
        let urlEnviar = "https://";
        if (ambienteAplicacion === "local") {
          urlEnviar = "http://";
        }
        urlEnviar =
          urlEnviar +
          window.location.host +
          "/resumen-cotizacion?id=" +
          this.props.dataProductoCarrito.productosCarrito.idCarrito +
          "&paso=resumen" +
          "" +
          (this.state.codigoProductoEspecial != null
            ? "&codigoProductoEspecial=" + this.state.codigoProductoEspecial
            : "");
        const datosActualizarCarrito = {
          empresa: "AIGMETROPOLITANA",
          plataforma: "WEB",
          idcarrito: this.props.dataProductoCarrito.productosCarrito.idCarrito,
          placa: this.props.datosCotizacion.datosPlaca.placa,
          valoresActualizar: {
            motor: motor.toUpperCase(),
            chasis: chasis.toUpperCase(),
            color: color,
            tipo: valtipo,
            capacidad: capacidad,
            ...(this.state.codigoProductoEspecial === 'comparador' || this.state.codigoProductoEspecial === 'pits' ? { tipoCombustible: this.state.tipoCombustible } : {}),
          },
          url: urlEnviar,
        };
        const datosActualizarCarritoJSON = JSON.stringify(
          datosActualizarCarrito
        );
        console.log("datosActualizarCarrito " + datosActualizarCarritoJSON);
        const arrayProductos = this.props.dataProductoCarrito;
        await this.props.fetchGuardarDatosAdiconalesCarrito(
          datosActualizarCarrito,
          arrayProductos
        );
        this.props.history.push({
          pathname: "/resumen-cotizacion",
          search:
            `?id=${this.props.dataProductoCarrito.productosCarrito.idCarrito}&paso=resumen` +
            "" +
            (this.state.codigoProductoEspecial != null
              ? "&codigoProductoEspecial=" + this.state.codigoProductoEspecial
              : ""),
          state: { textoBreadcrumbs: this.props.location.state && this.props.location.state.textoBreadcrumbs ? this.props.location.state.textoBreadcrumbs : "" }
        });
      } else if (
        selectedOptionColores === null ||
        selectedOptionColores === "" ||
        selectedOptionColores === undefined
      ) {
        this.setState({ hasColorError: true });
      }
      //this.props.history.replace("/resumen-cotizacion");
    } else {
      error = false;

      let datosPlaca = this.props.datosCotizacion.datosPlaca;

      datosPlaca.autoConcesionaria = autoConcesionaria

      if (accesoriosHabilitado) {
        if (selectedOption === null || selectedOption.length === 0) {
          error = true;
        } else {
          let valorExtras =
            (valorAsegurado * this.props.datosCotizacion.porcentajeExtras) /
            100;
          if (valorAccesorios === "" || valorAccesorios < 0) {
            error = true;
          } else if (valorAccesorios <= valorExtras) {
            const datosAccesorios = {
              accesorios: selectedOption,
              valorAccesorios: valorAccesorios,
            };
            datosPlaca.datosAccesorios = datosAccesorios;
          } else {
            error = true;
          }
        }
      } else {
        const datosAccesorios = {
          accesorios: [],
          valorAccesorios: 0,
        };
        datosPlaca.datosAccesorios = datosAccesorios;
      }

      if (
        (
          this.state.codigoProductoEspecial == "comparador" ||
          this.state.codigoProductoEspecial == "pits" ||
          this.state.codigoProductoEspecial == "vehiculosKilometrosPaquete"
        ) &&
        (
          !celular ||
          celular.trim() == "" ||
          celular.length < 7 ||
          celular.length > 10
        )
      ) {
        error = true
      }

      if ((parseInt(this.state.tipoDocumento) == 3) && (this.state.fechaEmisionPasaporte == null || this.state.fechaCaducidadPasaporte == null || this.state.fechaIngresoPais == null)) {
        error = true
      }
      //console.log("formulario continuar des accesorios", accesoriosHabilitado, error)

      if (!error) {
        delete datosPlaca.arrayMarcas;
        delete datosPlaca.marcaSeleccionada;
        delete datosPlaca.arrayModelos;
        delete datosPlaca.modeloSeleccionado;
        datosPlaca.anio = anio;
        datosPlaca.chasis = chasis;
        datosPlaca.rastreoSatelital = rastreo;
        datosPlaca.valorAsegurado = valorAsegurado;
        datosPlaca.motor = motor;
        datosPlaca.capacidad = capacidad;
        datosPlaca.tipo = tipoSeleccionado;
        datosPlaca.tipoCombustible = this.state.tipoCombustible;
        //Agregar parametrosde deducibles y responsabilidad civil
        datosPlaca.deducible = deducibleSelected;
        delete datosPlaca.porcentajeDeducibleOdTotalDanio;
        delete datosPlaca.porcentajeDeducibleTotalTheftRobo;
        datosPlaca.rc = rcSelected;
        //Agregar array de Amparos Adicionales
        var ValorAmparosAdicionales = {
          gastosMedicos: amparoGastosMedicosCheked,
          accidentesPersonales: amparoAccidentesPersonalesCheked,
          gastosTransporte: amparoGastosTransporteCheked,
          amparoPatrimonial: amparoPatrimonialCheked,
          objetosOlvidados: amparoObjetosOlvidadosCheked,
          gastosFunerarios: amparoGastosFunerariosCheked,
          amparoSustituto: amparoAutoSustitutoCheked,
          llaveProtegida: amparoLlaveProtegidaCheked,
          documentosProtegidos: amparoDocumentosProtegidosCheked,
        };
        datosPlaca.amparos = ValorAmparosAdicionales;

        this.props.setDatosPlaca(datosPlaca);

        let datosPersona = this.props.datosCotizacion.datosPersona;
        datosPersona.codigoTerritorio = territorioSeleccionado;
        const territorioObtenido = this.state.arrayTerritorios.filter(
          (modelo) => modelo.id === territorioSeleccionado
        );


        if (
          this.state.codigoProductoEspecial != "comparador" &&
          this.state.codigoProductoEspecial != "pits" &&
          this.state.codigoProductoEspecial != "vehiculosKilometrosPaquete" &&
          this.state.codigoProductoEspecial != "KilometrosConsumidos"
        ) {
          datosPersona.provCodigoCore = territorioObtenido[0].provCodigoCore;
          datosPersona.paiCodigoCore = territorioObtenido[0].paiCodigoCore;
          datosPersona.codigoTerritorio = territorioObtenido[0].id;


        }


        //ACTUALIZAR OBJETO DATOS PERSONA

        datosPersona.cedula =
          cedulaError !== undefined && cedulaError !== ""
            ? cedulaError
            : cedula;

        datosPersona.celular =
          celularError !== undefined && celularError !== ""
            ? celularError
            : celular;
        datosPersona.nombre = nombre;
        datosPersona.fechaNacimiento = fechaNacimiento;

        let obj = this.props.catalogoCotizacion.estadosCiviles.filter(
          (item) => item.id === parseInt(estadoCivil)
        );
        obj = obj[0];
        datosPersona.codigoEstadoCivil = estadoCivil;
        datosPersona.estadoCivil = obj.name;

        let obj1 = this.props.catalogoCotizacion.generos.filter(
          (item) => parseInt(item.id) === parseInt(genero)
        );
        obj1 = obj1[0];
        datosPersona.genero = obj1.name;
        datosPersona.codigoGenero = genero;

        this.props.setDatosPersona(datosPersona);

        let arrayProductos = this.props.dataProductoCarrito.productosCarrito
          .carProductos;


        let productoObtenido = arrayProductos.filter(
          (producto) => producto.datosProducto.placa === placa
        );

        ///////////

        let datosPersonaAsegurado = this.props.datosCotizacion.datosPersonaAsegurado;

        if (!datosPersonaAsegurado) {
          if (productoObtenido && productoObtenido[0]) {
            console.log('datosPersonaAsegurado', productoObtenido[0])
            if (productoObtenido[0].datosAsegurado) {
              datosPersonaAsegurado = productoObtenido[0].datosAsegurado
            }
          }
        }
        if (datosPersonaAsegurado) {

          datosPersonaAsegurado.codigoTerritorio = territorioSeleccionado;



          if (
            this.state.codigoProductoEspecial != "comparador" &&
            this.state.codigoProductoEspecial != "pits" &&
            this.state.codigoProductoEspecial != "vehiculosKilometrosPaquete" &&
            this.state.codigoProductoEspecial != "KilometrosConsumidos"
          ) {
            datosPersonaAsegurado.provCodigoCore = territorioObtenido[0].provCodigoCore;
            datosPersonaAsegurado.paiCodigoCore = territorioObtenido[0].paiCodigoCore;
          }


          //ACTUALIZAR OBJETO DATOS PERSONA

          datosPersonaAsegurado.cedula =
            cedulaError !== undefined && cedulaError !== ""
              ? cedulaError
              : cedula;

          datosPersona.celular =
            celularError !== undefined && celularError !== ""
              ? celularError
              : celular;
          datosPersona.nombre = nombre;
          datosPersona.fechaNacimiento = fechaNacimiento;

          let obj2 = this.props.catalogoCotizacion.estadosCiviles.filter(
            (item) => item.id === parseInt(estadoCivilAsegurado)
          );
          obj = obj[0];
          datosPersonaAsegurado.codigoEstadoCivil = estadoCivilAsegurado;
          datosPersonaAsegurado.estadoCivil = obj2.name;

          let obj3 = this.props.catalogoCotizacion.generos.filter(
            (item) => parseInt(item.id) === parseInt(generoAsegurado)
          );
          obj3 = obj3[0];
          if (obj3 && obj3.name) {
            datosPersonaAsegurado.genero = obj3.name;
          }

          datosPersonaAsegurado.codigoGenero = generoAsegurado;

          this.props.setDatosPersonaAsegurado(datosPersonaAsegurado);

        }
        ///////////

        let fechaCalculoEdadAux = fechaNacimiento.split("/");
        let fechaCalculoEdad = `${fechaCalculoEdadAux[2]}-${fechaCalculoEdadAux[1]}-${fechaCalculoEdadAux[0]}`;
        //Validar Edad de las personas
        let banderaEdad = true;
        let hoy = new Date();
        let cumpleanos = new Date(fechaCalculoEdad);
        let edad = hoy.getFullYear() - cumpleanos.getFullYear();
        let m = hoy.getMonth() - cumpleanos.getMonth();
        if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
          edad--;
        }


        let fechaCalculoEdadAuxAsegurado =fechaNacimientoAsegurado ? fechaNacimientoAsegurado.split("/") :new Date().toString("M/d/yyyy") ;
        let fechaCalculoEdadAsegurado = `${fechaCalculoEdadAuxAsegurado[2]}-${fechaCalculoEdadAuxAsegurado[1]}-${fechaCalculoEdadAuxAsegurado[0]}`;
        //Validar Edad de las personas
        let banderaEdadAsegurado = true;

        let hoyAsegurado = new Date();
        let cumpleanosAsegurado = new Date(fechaCalculoEdadAsegurado);
        let edadAsegurado = hoyAsegurado.getFullYear() - cumpleanosAsegurado.getFullYear();
        let mAsegurado = hoy.getMonth() - cumpleanosAsegurado.getMonth();
        if (mAsegurado < 0 || (mAsegurado === 0 && hoyAsegurado.getDate() < cumpleanosAsegurado.getDate())) {
          edadAsegurado--;
        }


        if (
          edad >=
          this.props.datosCotizacion.datosPersona.validacionesEdad
            .valorMinimoEdad &&
          edad <=
          this.props.datosCotizacion.datosPersona.validacionesEdad
            .valorMaximoEdad
        ) {
        } else {
          banderaEdad = false;
          this.setState({ mostrarMensajeValidarEdad: true });
        }



        if(!mismosDatos && (tipoDocumentoAsegurado.toString() == '1')){

          if (
            edadAsegurado >=
            this.props.datosCotizacion.datosPersona.validacionesEdad
              .valorMinimoEdad 
          ) {
          } else {
            banderaEdadAsegurado = false;
            this.setState({ mostrarMensajeValidarEdadAsegurado: true });
          }

        }


      

        console.log('this.props.datosCotizacion.datosPersonaAsegurado', this.props.datosCotizacion.datosPersonaAsegurado)

        



        //Fin Validar Edad de las personas
        const esAigAutoOPrac = this.state.codigoProductoEspecial === 'comparador' || this.state.codigoProductoEspecial === 'pits';
        if (
          valorAsegurado !== "" &&
          valorAsegurado > 0 &&
          nombre !== "" &&
          fechaNacimiento !== "" &&
          estadoCivil !== "" &&
          genero !== "" &&
          banderaEdad &&
          banderaEdadAsegurado &&
          (!esAigAutoOPrac || !this.state.hasTipoCombustibleError)
        ) {
          this.setState({
            formEditado: inicial? true: false,
          });

          var datosClienteAux = this.props.datosCotizacion.datosPersona;

          datosClienteAux.tipoDocumento = this.state.tipoDocumento

          var planSeleccionadoAux = null;

          const codEspecial = new URLSearchParams(this.props.location.search).get("codigoProductoEspecial")

          var amparosAux = {}
          var amparosAuxFalse = {}



          if (codEspecial == 'comparador' || codEspecial == 'pits') {

            console.log('this.state.planComparadorSeleccionado', this.state.planComparadorSeleccionado)

            planSeleccionadoAux = this.state.planComparadorSeleccionado ? this.state.planComparadorSeleccionado.codigo : productoObtenido10 && productoObtenido10.datosCliente ? productoObtenido10.datosCliente.planAux : null

            this.state.coberturasAdicionalesComparador.forEach(element => {
              amparosAux[element.codigo] = true
            });



            if (this.state.planComparadorSeleccionado) {

              this.state.planComparadorSeleccionado.coberturasAdicionales.forEach(element => {

                var existe = this.state.coberturasAdicionalesComparador.find(cob => cob.codigo == element.codigo)
                if (!existe) {
                  amparosAuxFalse[element.codigo] = false
                }
              });
            }


             if (!productoObtenido10) {
              //Obtener Producto cuando no es edicion para obtener Deducibles
              let placacotizada = this.props.datosCotizacion.datosPlaca.placa;
              let arrayProductos1 = this.props.dataProductoCarrito.productosCarrito
                .carProductos;
               productoObtenido10 = arrayProductos1.find(
                (producto) => producto.datosProducto.placa === placacotizada
              );
            }
 


            ValorAmparosAdicionales = this.state.planComparadorSeleccionado ? { ...ValorAmparosAdicionales, ...amparosAuxFalse, ...amparosAux } : productoObtenido10.datosCliente.amparosAux



          } else {
            planSeleccionadoAux = this.state.planSeleccionado != null
              ? this.state.planSeleccionado.codigo
              : "900"

          }

          var datosClienteAux = this.props.datosCotizacion.datosPersona;

          datosClienteAux.tipoDocumento = this.state.tipoDocumento

          if (this.state.fechaEmisionPasaporte && this.state.fechaCaducidadPasaporte && this.state.fechaIngresoPais) {
            datosClienteAux.fechaEmisionPasaporte = this.state.fechaEmisionPasaporte
            datosClienteAux.fechaCaducidadPasaporte = this.state.fechaCaducidadPasaporte
            datosClienteAux.fechaIngresoPais = this.state.fechaIngresoPais
          }



          if (codEspecial == 'comparador' || codEspecial == 'pits') {
            const territorioEncontrado2 = this.state.arrayTerritoriosComparador.find(terr => terr.value == this.state.territorioSeleccionadoComparador.value)



            datosClienteAux.codigoTerritorio = territorioEncontrado2.provCodigoCore
            datosClienteAux.provCodigoCore = territorioEncontrado2.provCodigoCore

            datosClienteAux.planAux = planSeleccionadoAux
            datosClienteAux.amparosAux = ValorAmparosAdicionales
          }

          if (
            codEspecial == 'vehiculosKilometrosPaquete' ||
            codEspecial == 'KilometrosConsumidos'

          ) {
            const territorioEncontrado2 = this.state.arrayTerritoriosComparador.find(terr => terr.value == this.state.territorioSeleccionadoComparador.value)
            datosClienteAux.codigoTerritorio = territorioEncontrado2.provCodigoCore
            datosClienteAux.provCodigoCore = territorioEncontrado2.provCodigoCore
            datosClienteAux.amparosAux = ValorAmparosAdicionales
          }

          if (parentesco != '') {

            const parentescoEncontrado = this.props.catalogoCotizacion.parentescos.find(prt => prt.id == parentesco)
            if (parentescoEncontrado) {
              datosClienteAux.parCodigo = parentescoEncontrado.id
              datosClienteAux.parNombre = parentescoEncontrado.name

            } else {
              return false
            }


          } else {
            return false
          }

          var datosAseguradorAux = null;
          const edadAsegurado = moment().diff(moment(this.state.fechaNacimientoAsegurado, 'DD/MM/YYYY'), 'years');
          if (this.state.mismosDatos) {
            datosAseguradorAux = { diferenteAConductor: false, mismosDatos: this.state.mismosDatos, ...datosClienteAux, edad: edadAsegurado, codTipodocumento: datosClienteAux.tipoDocumento };
          } else {
            const generoEncontradoAsegurado = this.props.catalogoCotizacion.generos.find(gro => gro.id == this.state.generoAsegurado);
            const estadoCivilEncontradoAsegurado = this.props.catalogoCotizacion.estadosCiviles.find(gro => gro.id == this.state.estadoCivilAsegurado);
          
            datosAseguradorAux = {
              diferenteAConductor: true,
              mismosDatos: this.state.mismosDatos,
              cedula: this.state.cedulaAsegurado,
              celular: this.state.celularAsegurado,
              nombre: this.state.nombreAsegurado,
              fechaNacimiento: this.state.fechaNacimientoAsegurado,
              edad: edadAsegurado,
              estadoCivil: estadoCivilEncontradoAsegurado.name,
              codigoEstadoCivil: this.state.estadoCivilAsegurado,
              genero: generoEncontradoAsegurado.name,
              codigoGenero: this.state.generoAsegurado,
              codigoTerritorio: this.state.territorioSeleccionadoComparadorAsegurado.value,
              provCodigoCore: this.state.territorioSeleccionadoComparadorAsegurado.provCodigoCore,
              ciudad: this.state.ciudadSeleccionada,
              provincia: this.state.territorioSeleccionadoComparadorAsegurado,
              paiCodigoCore: "1",
              tipoDocumento: this.state.tipoDocumentoAsegurado,
              codTipodocumento: this.state.tipoDocumentoAsegurado,
              personeria: this.state.personeria
            };
          }
          







          const datosCarrito = {
            empresa: "AIGMETROPOLITANA",
            plataforma: "WEB",
            cliCodigoCore: this.props.dataProductoCarrito.productosCarrito
              .cliCodigoCore, //EnviarCodigoCore Persona creadora carrito
            datosProducto: datosPlaca,
            datosCliente: datosClienteAux,
            datosAsegurado: datosAseguradorAux,
            mismosDatos: this.state.mismosDatos,
            datosCoberturas: [],
            datosAmparos: [],
            amparos: codEspecial == 'comparador' || codEspecial == 'pits' ? ValorAmparosAdicionales : [],
            placa: datosPlaca.placa,
            accion: "agregar",
            editar: true,
            carCodigo: this.props.dataProductoCarrito.productosCarrito
              .idCarrito,
            datosAsesor: {
              nombre: `${this.props.datosUsuarios.nombres} ${this.props.datosUsuarios.apellidos}`,
              codigoCore: this.props.datosUsuarios.cliCodigoCore,
              sucursalSeleccionada: this.props.datosSucursales
                .sucursalSelecionadaAsesor,
              ambiente: ambienteAplicacion,
            },
            esCotizacion: false,
            amparosAdicionales: ValorAmparosAdicionales,
            codigoProductoEspecial: this.state.codigoProductoEspecial,
            plan: planSeleccionadoAux,
          };

          const datosCarritoJSON = JSON.stringify(datosCarrito);
          console.log("Enviar carrtio ", datosCarrito);

          await this.props.modificarCarrito(datosCarrito);

          console.log('verErrores', this.props.dataProductoCarrito)

          if(this.props.dataProductoCarrito.hasErrored){
            this.setState({
              errorProducto: true,
              mensajeErrorProducto: this.props.dataProductoCarrito.error
            })
          }else{
            this.setState({
              errorProducto: false,
              mensajeErrorProducto: ''
            })
          }

          this.setState({
            planesComparador: [],
          })

          this.setState({
            planesComparador: this.props.planesComparador
          })


          var buscarSeleccionado = null

          if (this.state.codigoProductoEspecial == "comparador" || this.state.codigoProductoEspecial == "pits") {
            buscarSeleccionado = this.props.planesComparador.find(plan => plan.codigo == this.state.planComparadorSeleccionado ? this.state.planComparadorSeleccionado.codigo : productoObtenido10 ? productoObtenido10.datosCliente.planAux : null)
          }



          if (buscarSeleccionado) {
            this.setState({
              planComparadorSeleccionado: buscarSeleccionado
            })
          }




          this.props.listarCoberturas(
            this.props.datosCotizacion.datosPersona.codigoTerritorio
          );
          this.props.listarAmparosAdicionales(
            this.props.datosCotizacion.datosPersona.codigoTerritorio,
            codEspecial
          );

          //Agregado para mostrar los totales en la cabecera
          let datosJSON = {
            empresa: "AIGMETROPOLITANA",
            plataforma: "WEB",
            idCarrito: this.props.dataProductoCarrito.productosCarrito
              .idCarrito,
          };
          await this.props.datosFacturacion(datosJSON);
          //Cargar Totales de la cabecera
          if (
            this.props.dataFacturacion !== undefined &&
            this.props.dataFacturacion !== ""
          ) {
            let param = {
              pathIcono: this.props.dataFacturacion.pathIconoTotalesCabecera
                ? this.props.dataFacturacion.pathIconoTotalesCabecera
                : "",
              totalItems: this.props.dataFacturacion.numItemsCarrito
                ? this.props.dataFacturacion.numItemsCarrito
                : "0",
              totalPrima:
                this.props.dataFacturacion.carValoresTotales &&
                  this.props.dataFacturacion.carValoresTotales.primaTotal
                  ? this.props.dataFacturacion.carValoresTotales.primaTotal
                  : "0.00",
              ramoCotizador: this.props.dataFacturacion.carDescripcionRamo
                ? this.props.dataFacturacion.carDescripcionRamo
                : "",
            };
            await this.props.actualizarTotalesCabecera(param);
          }
        }
      }
    }
    this.obtenerPlanesKmPaquete();
  };
  planTemplate(plan) {
    return (
      <div className="car-details">
        <div className="p-grid p-nogutter">
          <div className="p-col-12"></div>
          <div className="p-col-12 car-data">
            <div className="car-title">{plan.descripcion}</div>
            <div className="car-subtitle">{plan.code} </div>

            <div className="car-buttons">
              <Button color="primary" onClick={() => this.onSelect(plan)}>
                Seleccionar
              </Button>
              &nbsp;
            </div>
          </div>
        </div>
      </div>
    );
  }
  onSelect = (value) => {

    if (value) {
      this.setState({
        planSeleccionado: value,
        formEditado: true,
      });
    }


  };

  onEditarPlaca = (e) => {

    var search = `?accion=editarPlaca&editarPlaca=true`

    if (this.state.codigoProductoEspecial == "comparador") {
      search = '?accion=editarPlaca&editarPlaca=true&codigoProductoEspecial=comparador'
    }
    if (this.state.codigoProductoEspecial == "pits") {
      search = '?accion=editarPlaca&editarPlaca=true&codigoProductoEspecial=pits'
    }
    if (this.state.codigoProductoEspecial == "vehiculosKilometrosPaquete") {
      search = '?accion=editarPlaca&editarPlaca=true&codigoProductoEspecial=vehiculosKilometrosPaquete'
    }
    if (this.state.codigoProductoEspecial == "KilometrosConsumidos") {
      search = '?accion=editarPlaca&editarPlaca=true&codigoProductoEspecial=KilometrosConsumidos'
    }
    console.log('Redireccionar')
    this.props.history.push({
      pathname: "/cotizacion",
      search: search

    });
  }

  render() {
    const {
      validate,
      validateAsegurado,
      mismosDatos,
      placa,
      chasis,
      motor,
      cedula,
      cedulaAsegurado,
      nombreAsegurado,
      fechaNacimientoAsegurado,
      estadoCivilAsegurado,
      cedular,
      marca,
      anio,
      modelo,
      tipo,
      rastreo,
      nombre,
      fechaNacimiento,
      estadoCivil,
      parentesco,
      genero,
      generoAsegurado,
      territorioSeleccionado,
      territorioSeleccionadoComparador,
      territorioSeleccionadoComparadorAsegurado,
      ciudadSeleccionada,
      ciudades,
      formEditado,
      valorAsegurado,
      arrayTerritorios,
      arrayTerritoriosComparador,
      accesoriosHabilitado,
      autoConcesionaria,
      selectedOption,
      selectedOptionColores,
      valorAccesorios,
      arrayAccesorios,
      arrayColores,
      hasValorAccesoriosError,
      cedulaError,
      cedulaAseguradoError,
      celularError,
      hasPlacaError,
      clase,
      hasColorError,
      tipoSeleccionado,
      arrayTipos,
      contadorCoberturas,
      amparoGastosMedicosCheked,
      amparoAccidentesPersonalesCheked,
      amparoGastosTransporteCheked,
      amparoPatrimonialCheked,
      amparoObjetosOlvidadosCheked,
      amparoGastosFunerariosCheked,
      amparoAutoSustitutoCheked,
      amparoLlaveProtegidaCheked,
      amparoDocumentosProtegidosCheked,
      capacidad,
      arrayDeducibles,
      deducibleSelected,
      arrayDeduciblesTotalDanio,
      deducibleTotalDanioSelected,
      arrayDeduciblesTotalRobo,
      deducibleTotalRoboSelected,
      arrayRc,
      rcSelected,
      verDeducibles,
      verRc,
      mostrarMensajeValidarEdad,
      mostrarMensajeValidarEdadAsegurado
    } = this.state;

    // codigo producto especial, para distinguir entre cotizadores de vehiculos
    const codEspecial = new URLSearchParams(this.props.location.search).get("codigoProductoEspecial")
    const anioActual = new Date().getFullYear()
    //console.log(this.state.validate, hasPlacaError);
    const { datosCotizacion, datosCoberturas, datosAmparos } = this.props;
    console.log("arrayColores121 ", selectedOptionColores, arrayColores );
    let posicioncolor = 0;
    let i = 0;

   let index =  arrayColores.findIndex((element) => element.value === parseInt(selectedOptionColores));

   posicioncolor = index >=0 ? index : undefined


    //Obtener Amparos Adicionales
    let ObtenerAmparoGastosMedicos = undefined;
    let ObtenerAmparoAccidentesPersonales = undefined;
    let ObtenerAmparoGastosTransporte = undefined;
    let ObtenerAmparoPatrimonial = undefined;
    let ObtenerAmparoObjetosOlvidados = undefined;
    let ObtenerAmparoGastosFunerarios = undefined;
    let ObtenerAmparoAutoSustituto = undefined;
    let ObtenerAmparoLlaveProtegida = undefined;
    let ObtenerAmparoDocumentosProtegidos = undefined;
    if (
      datosAmparos !== null &&
      datosAmparos !== undefined &&
      Object.keys(datosAmparos).length > 0
    ) {
      ObtenerAmparoGastosMedicos = datosAmparos.filter(
        (amparo) => amparo.cobNombre === "GM"
      );
      ObtenerAmparoAccidentesPersonales = datosAmparos.filter(
        (amparo) => amparo.cobNombre === "AP"
      );
      ObtenerAmparoGastosTransporte = datosAmparos.filter(
        (amparo) => amparo.cobNombre === "GTR"
      );
      ObtenerAmparoPatrimonial = datosAmparos.filter(
        (amparo) => amparo.cobNombre === "APAT"
      );
      ObtenerAmparoObjetosOlvidados = datosAmparos.filter(
        (amparo) => amparo.cobNombre === "OOL"
      );
      ObtenerAmparoGastosFunerarios = datosAmparos.filter(
        (amparo) => amparo.cobNombre === "GASTOS FUN"
      );
      ObtenerAmparoAutoSustituto = datosAmparos.filter(
        (amparo) => amparo.cobNombre === "AUTOSUST"
      );
      ObtenerAmparoLlaveProtegida = datosAmparos.filter(
        (amparo) => amparo.cobNombre === "LLAVEPROT"
      );
      ObtenerAmparoDocumentosProtegidos = datosAmparos.filter(
        (amparo) => amparo.cobNombre === "DOCPROT"
      );
    }

    let fechaNacimientoArray = new Date().toString("M/d/yyyy");
    if (fechaNacimiento) {
      fechaNacimientoArray = fechaNacimiento.split("/");
      fechaNacimientoArray =
        fechaNacimientoArray[2] +
        "/" +
        fechaNacimientoArray[1] +
        "/" +
        fechaNacimientoArray[0];
    }

    let fechaNacimientoAseguradoArray = new Date().toString("M/d/yyyy");
    if (fechaNacimientoAsegurado) {
      fechaNacimientoAseguradoArray = fechaNacimientoAsegurado.split("/");
      fechaNacimientoAseguradoArray =
        fechaNacimientoAseguradoArray[2] +
        "/" +
        fechaNacimientoAseguradoArray[1] +
        "/" +
        fechaNacimientoAseguradoArray[0];
    }

    let ValueCedula = cedula;
    if (this.props.datosCotizacion.consultarCedulaHasError) {
     // ValueCedula = cedulaError;
    }

    let ValueCedulaAsegurado = cedulaAsegurado;
    // if (this.props.datosCotizacion.consultarCedulaAseguradoHasError) {
    //   ValueCedulaAsegurado = cedulaAseguradoError;
    // }

    let editarMotor = false
    if (datosCotizacion.datosPlaca.motor === "" || datosCotizacion.datosPlaca.noSeEncontroInformacionAuto) {
      editarMotor = true
    }


    let editarChasis = false
    if (datosCotizacion.datosPlaca.chasis === "" || datosCotizacion.datosPlaca.noSeEncontroInformacionAuto) {
      editarChasis = true
    }





    //console.log("verRc",datosCotizacion.datosPlaca ,editarMotor,editarChasis)
    return (
      <LoadingScreen
        loading={
          this.props.datosCotizacion.consultarPlacaIsLoading ||
          this.props.datosCotizacion.consultarCedulaIsLoading ||
          this.props.dataProductoCarrito.isLoading
        }
        bgColor="#f1f1f1"
        spinnerColor="#001871"
        textColor="#676767"
        logoSrc={logo}
        text="Obteniendo datos..."
      >
        {console.log('espero', this.props )}
        <Page
          title={this.state.codigoProductoEspecial == "comparador" || this.state.codigoProductoEspecial == "pits"
            ? this.state.codigoProductoEspecial == "comparador" ? 'AIG AUTO' : 'PractiAuto'
            : "Cotización de vehículos"
          }

          breadcrumbs={[{ name: this.state.codigoProductoEspecial == "comparador" || this.state.codigoProductoEspecial == "pits"
            ? this.state.codigoProductoEspecial == "comparador" ? 'AIG AUTO' : 'PractiAuto'
            : "Cotización de vehículos", active: true }]
          }
        >
          <Row>
            <Col lg={8} md={12} sm={12} xs={12}>
              <div class="container-step">
                <div class="wrapper-step">
                  <div class="arrow-steps clearfix-step">
                    <div class="step current"> {`1. Cotización`} </div>
                    <div class="step"> {`2. Resumen`} </div>
                    <div class="step"> {`3. Confirmación`} </div>
                    <div class="step"> {` 4. Forma de Pago `} </div>
                    <div class="step"> {` 5. Formulario de Vinculación `} </div>
                    <div class="step"> {` 6. Emisión `} </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col
              lg={8}
              md={12}
              sm={12}
              xs={12}
              className="detalle-cotizacion-box"
            >
              <Card className="flex-row">
                <CardBody>
                  <h4 style={{ fontWeight: "bold" }}> Datos del Vehículo</h4>
                  <p />
                  <div style={styles.cardDatosVehiculo}>
                    <Row>
                      <Col md={4}>
                        <Row>
                          <Col md={5}>
                            <span style={styles.tituloVehiculo}>
                              Marca:
                            </span>
                          </Col>
                          <Col md={7}>
                            <span style={styles.subTituloVehiculo}>
                              {datosCotizacion.datosPlaca.marca}
                            </span>
                          </Col>
                        </Row>
                      </Col>
                      <Col md={4}>
                        <Row>
                          <Col md={5}>
                            <span style={styles.tituloVehiculo}>
                              Modelo:
                            </span>
                          </Col>
                          <Col md={7}>
                            <span style={styles.subTituloVehiculo}>
                              {datosCotizacion.datosPlaca.modelo}
                            </span>
                          </Col>
                        </Row>
                      </Col>
                      {
                        (datosCotizacion.datosPlaca.placa && datosCotizacion.datosPlaca.placa != "") &&
                        <Col md={4}>
                          <Row>
                            <Col md={5}>
                              <span style={styles.tituloVehiculo}>
                                Placa:
                              </span>
                            </Col>
                            <Col md={7}>
                              <span style={styles.subTituloVehiculo}>
                                {datosCotizacion.datosPlaca.placa}
                              </span>
                            </Col>
                          </Row>
                        </Col>
                      }

                      <Col md={4}>
                        <Row>
                          <Col md={5}>
                            <span style={styles.tituloVehiculo}>
                              Clase:
                            </span>
                          </Col>
                          <Col md={7}>
                            <span style={styles.subTituloVehiculo}>
                              {datosCotizacion.datosPlaca.clase}
                            </span>
                          </Col>
                        </Row>
                      </Col>
                      <Col md={4}>
                        <Row>
                          <Col md={5}>
                            <span style={styles.tituloVehiculo}>
                              Uso:
                            </span>
                          </Col>
                          <Col md={7}>
                            <span style={styles.subTituloVehiculo}>
                              {datosCotizacion.datosPlaca.tipo}
                            </span>
                          </Col>
                        </Row>
                      </Col>
                      <Col md={4}>
                        <Row>
                          <Col md={5}>
                            <span style={styles.tituloVehiculo}>
                              Año:
                            </span>
                          </Col>
                          <Col md={7}>
                            <span style={styles.subTituloVehiculo}>
                              {datosCotizacion.datosPlaca.anio}
                            </span>
                          </Col>
                        </Row>
                      </Col>
                    </Row>

                  </div>
                  <Row>
                    <Col lg={5} md={6} sm={6} xs={12}>
                      <h5 style={{ fontWeight: "bold" }}>
                        ¿El Vehículo posee Rastreo Satelital?
                      </h5>
                    </Col>
                    <Col lg={1} md={6} sm={6} xs={12}>
                      <Checkbox
                        id={"agreement"} // Optional.[String].Default: "".  Input ID.
                        name={"agreement"} // Optional.[String].Default: "". Input name
                        classNameInputBox={'check-uber'}
                        value={rastreo} // Required.[String].Default: "".
                        onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                        checked={rastreo} // Required.[Bool].Default: false.
                        onChange={(rastreo, e) => {
                          this.setState({
                            rastreo,
                            formEditado: true,
                          });
                          //console.log(e);
                        }} // Required.[Func].Default: () => {}. Will return the value.
                        validationOption={{
                          name: "agreement", // Optional.[String].Default: "". To display in the Error message. i.e Please check the .
                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                        }}
                      />
                    </Col>


                  </Row>
                  <Row>
                    <Col lg={5} md={6} sm={6} xs={12}>
                      <h5 style={{ fontWeight: "bold" }}>
                        {" "}
                        ¿El Vehículo posee Accesorios Adicionales?{" "}
                      </h5>
                      <p />
                    </Col>
                    <Col lg={1} md={6} sm={6} xs={12}>
                      <Checkbox
                        id={"accesorios"} // Optional.[String].Default: "".  Input ID.
                        name={"accesorios"} // Optional.[String].Default: "". Input name
                        classNameInputBox={'check-uber'}
                        //value={accesoriosHabilitado} // Required.[String].Default: "".
                        onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                        checked={accesoriosHabilitado} // Required.[Bool].Default: false.
                        onChange={(accesoriosHabilitado, e) => {
                          this.setState({
                            accesoriosHabilitado,
                            formEditado: true,
                          });
                          //console.log(e);
                        }} // Required.[Func].Default: () => {}. Will return the value.
                        validationOption={{
                          name: "accesorios", // Optional.[String].Default: "". To display in the Error message. i.e Please check the .
                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                        }}
                      />
                    </Col>
                  </Row>


                  {/*  <Row>
                    <Col lg={3} md={6} sm={6} xs={12}>
                      <h5 style={{ fontWeight: "bold" }}>Marca</h5>
                    </Col>
                    <Col lg={3} md={6} sm={6} xs={12}>
                      <Textbox
                        ref={this.textInput}
                        tabIndex="1"
                        type="text"
                        id="test"
                        name="test"
                        classNameInput={
                          datosCotizacion.datosPlaca.marca === ""
                            ? "form-control"
                            : "input-type-label form-control"
                        }
                        value={marca}
                      />
                    </Col>
                    <Col lg={3} md={6} sm={6} xs={12}>
                      <h5 style={{ fontWeight: "bold" }}>Año</h5>
                    </Col>
                    <Col lg={3} md={6} sm={6} xs={12}>
                      <Textbox
                        ref={this.textInput}
                        tabIndex="1"
                        type="text"
                        id="test"
                        name="test"
                        classNameInput={
                          datosCotizacion.datosPlaca.anio === ""
                            ? "form-control"
                            : "input-type-label form-control"
                        }
                        value={anio}
                      />
                    </Col>
                  </Row> */}
                  {/*    <Row>
                    <Col lg={3} md={6} sm={6} xs={12}>
                      <h5 style={{ fontWeight: "bold" }}>Modelo</h5>
                    </Col>
                    <Col lg={9} md={6} sm={6} xs={12}>
                      <Textbox
                        ref={this.textInput}
                        tabIndex="1"
                        type="text"
                        id="test"
                        name="test"
                        classNameInput={
                          datosCotizacion.datosPlaca.modelo === ""
                            ? "form-control"
                            : "input-type-label form-control"
                        }
                        value={modelo}
                      />
                    </Col>
                  </Row> */}


                  {/* <Row>
                    <Col lg={3} md={6} sm={6} xs={12}>
                      <h5 style={{ fontWeight: "bold" }}>Clase</h5>
                    </Col>
                    <Col lg={9} md={6} sm={6} xs={12}>
                      <Textbox
                        tabIndex="1"
                        type="text"
                        id="test"
                        name="test"
                        classNameInput={
                          datosCotizacion.datosPlaca.clase === ""
                            ? "form-control"
                            : "input-type-label form-control"
                        }
                        value={clase}
                      />
                    </Col>
                  </Row> */}
                  {/*  <Row>
                    <Col lg={3} md={6} sm={6} xs={12}>
                      <h5 style={{ fontWeight: "bold" }}>Uso</h5>
                    </Col>
                    <Col lg={3} md={6} sm={6} xs={12}>
                      {this.props.datosCotizacion.datosPlaca.tipo === "v" && (
                        <Textbox
                          ref={this.textInput}
                          tabIndex="1"
                          type="text"
                          id="tipolabel"
                          name="tipolabel"
                          classNameInput={
                            datosCotizacion.datosPlaca.tipo === ""
                              ? "form-control"
                              : "input-type-label form-control"
                          }
                          value={datosCotizacion.datosPlaca.tipo}
                        />
                      )}
                      <Select1
                        id={"selectTipos"} // Optional.[String].Default: "". Input ID.
                        name={"selectTipos"} // Optional.[String].Default: "". Input name.
                        //value={datosCotizacion.datosPlaca.tipo!=="" ? datosCotizacion.datosPlaca.tipo :tipoSeleccionado} // Optional.[String].Default: "".
                        value={tipoSeleccionado} // Optional.[String].Default: "".
                        optionList={arrayTipos} // Required.[Array of Object(s)].Default: [].
                        onChange={(tipoSeleccionado, e) => {
                          this.setState({
                            tipoSeleccionado,
                            formEditado: true,
                          });
                          //console.log("tipoSeleccionado", tipoSeleccionado);
                        }} // Optional.[Func].Default: () => {}. Will return the value.
                        validate={validate}
                        validationCallback={(res) =>
                          //console.log(res)
                          this.setState({
                            hasTipoError: res,
                            validate: false,
                          })
                        }
                        classNameWrapper="bloquear-eventos-mouse"
                        classNameContainer="input-type-label padding-select-reactinputs" //Optional.[String].Default: "".
                        onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                        customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                        validationOption={{
                          name: "selectTipos", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                          msgOnError:
                            "Por favor seleccione el uso de su vehículo",
                        }}
                      />
                    </Col>
                    <Col lg={3} md={6} sm={6} xs={12}>
                      <h5 style={{ fontWeight: "bold" }}>Placa</h5>
                    </Col>
                    <Col lg={3} md={6} sm={6} xs={12}>
                      {datosCotizacion.datosPlaca.placa !== "" &&
                        <Textbox
                          ref={this.textInput}
                          tabIndex="1"
                          type="text"
                          id="test"
                          name="test"
                          classNameInput={
                            datosCotizacion.datosPlaca.placa === ""
                              ? "form-control"
                              : "input-type-label form-control"
                          }
                          value={placa}
                        />
                      }

                      {datosCotizacion.datosPlaca.placa === "" &&
                        <Button
                          className="btn btn-purple"
                          onClick={this.onEditarPlaca}
                          style={{ display: "block", margin: "0 0 0 auto" }}
                        >
                          <i className="fa fa-plus-circle" aria-hidden="true" /> INGRESAR PLACA
                        </Button>

                      }
                    </Col>
                  </Row> */}


                  {
                    (
                      parseInt(this.state.anio) >= parseInt(anioActual) &&
                      codEspecial !== 'vehiculosKilometrosPaquete' &&
                      codEspecial !== 'KilometrosConsumidos') &&
                    <Row>
                      <Col lg={5} md={6} sm={6} xs={12}>
                        <h5 style={{ fontWeight: "bold" }}>
                          {" "}
                          ¿El Vehículo aún no sale del Concesionario?{" "}
                        </h5>
                        <p />
                      </Col>
                      <Col lg={1} md={6} sm={6} xs={12}>
                        <Checkbox
                          id={"Concesionario"} // Optional.[String].Default: "".  Input ID.
                          name={"Concesionario"} // Optional.[String].Default: "". Input name
                          classNameInputBox={'check-uber'}
                          //value={accesoriosHabilitado} // Required.[String].Default: "".
                          onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                          checked={autoConcesionaria} // Required.[Bool].Default: false
                          onChange={(autoConcesionaria, e) => {
                            this.setState({
                              autoConcesionaria,
                              formEditado: true,
                            });
                            //console.log(e);
                          }} // Required.[Func].Default: () => {}. Will return the value.
                          validationOption={{
                            name: "autoConcesionaria", // Optional.[String].Default: "". To display in the Error message. i.e Please check the .
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                          }}
                        />
                      </Col>
                    </Row>
                  }

                  {accesoriosHabilitado && (
                    <Row>
                      <Col lg={6} md={6} sm={6} xs={6}>
                        <Select
                          value={selectedOption}
                          //value={arrayAccesoriosSeleccionados}
                          components={makeAnimated()}
                          onChange={this.handleChange}
                          options={arrayAccesorios}
                          isSearchable={true}
                          placeholder={
                            "Seleccione los accesorios extra que posee su vehiculo. Ej: Radio"
                          }
                          isMulti={true}
                        />
                        {(selectedOption === null ||
                          selectedOption.length === 0) && (
                            <span style={{ color: "red", fontSize: "1rem" }}>
                              Por favor ingrese al menos un accesorio
                            </span>
                          )}
                      </Col>
                      <Col lg={3} md={3} sm={3} xs={3}>
                        <h5 style={{ fontWeight: "bold" }}>Valor accesorios</h5>
                      </Col>
                      <Col lg={3} md={3} sm={3} xs={3}>

                        {

                        }


                        {this.props.datosCotizacion.porcentajeExtras &&
                          <Textbox
                            ref={this.textInput}
                            tabIndex="1"
                            validate={validate}
                            type="text"
                            id="test"
                            name="test"
                            classNameInput="form-control"
                            placeholder="Ingrese valor ejemplo ($ 120.50)"
                            value={valorAccesorios}
                            onChange={(valorAccesorios, e) => {
                              this.setState({
                                valorAccesorios,
                                formEditado: true,
                              });
                              //console.log(e);
                            }}
                            validationCallback={(res) =>
                              //console.log(res)
                              this.setState({
                                hasValorAccesoriosError: res,
                                validate: false,
                              })
                            }
                            onBlur={(e) => {
                              this.setState({ blur: true });
                              //console.log("BLUUUR");
                            }}
                            validationOption={{
                              name: "Valor accesorios", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                              check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                              required: false,
                              customFunc: (res) => {
                                //Optional.[Func].Default: none. Custom function. Returns true or err message
                                let valorExtras =
                                  (valorAsegurado *
                                    this.props.datosCotizacion.porcentajeExtras) /
                                  100;
                                if (valorAccesorios < 0) {
                                  return "El valor ingresado debe ser positivo";
                                } else if (valorAccesorios > valorExtras) {
                                  return `El valor ingresado debe ser menor a $ ${valorExtras}`;
                                } else if (res === "0") {
                                  //console.log("Validando: ", res)
                                  return "El valor ingresado debe ser mayor a 0";
                                } else if (res === "") {
                                  return "Debe ingresar un valor numérico";
                                }

                                return true;
                              },
                            }}
                          />

                        }



                      </Col>
                    </Row>
                  )}



                </CardBody>
              </Card>

          

              <Card>
                <CardBody>
                   

                  <Row>                              
                    <Col lg={3} md={6} sm={6} xs={12}>
                      <h5 style={{ fontWeight: "bold" }}>Valor Asegurado</h5>
                    </Col>
                    <Col lg={3} md={6} sm={6} xs={12}>

                      <NumberFormat
                        className="form-control"
                        disabled={false}
                        value={valorAsegurado}
                        thousandSeparator={','}
                        decimalSeparator={'.'}
                        decimalScale={2}
                        prefix={''}
                        onValueChange={(valor, e) => {

                          const error = valor.floatValue >= this.props.limitesVehiculos.limAvaluo.valMin && valor.floatValue <= this.props.limitesVehiculos.limAvaluo.valMax

                          this.setState({
                            valorAsegurado: valor.floatValue,
                            formEditado: true,
                            valorAseguradoValido: error

                          });


                        }}

                      />

                      {!this.state.valorAseguradoValido && parseFloat(valorAsegurado) > this.props.limitesVehiculos.limAvaluo.valMax && (
                        <span style={{ color: "red", fontSize: "1rem" }}>
                          Se permite asegurar vehículos de hasta ${this.props.limitesVehiculos.limAvaluo.valMax}
                        </span>
                      )}

                      {!this.state.valorAseguradoValido && parseFloat(valorAsegurado) < this.props.limitesVehiculos.limAvaluo.valMin && (
                        <span style={{ color: "red", fontSize: "1rem" }}>
                          Se permite asegurar vehículos mayor a  ${this.props.limitesVehiculos.limAvaluo.valMin - 1}
                        </span>
                      )}
                      {!this.state.valorAseguradoValido && (valorAsegurado === "" || valorAsegurado == undefined) && (
                        <span style={{ color: "red", fontSize: "1rem" }}>
                          Por favor ingrese el valor del avalúo.
                        </span>
                      )}
                      {/*  <Textbox
                        ref={this.textInput}
                        tabIndex="1"
                        type="text"
                        id="valorasegurado"
                        name="valorasegurado"
                        classNameInput="form-control"
                        value={valorAsegurado}
                     
                        onChange={(valorAsegurado, e) => {
                          this.setState({
                            valorAsegurado,
                            formEditado: true,
                          });
                          //console.log("valorAsegurado0",valorAsegurado);
                        }}
                        onBlur={(e) => {
                          this.setState({ blur: true });
                          //console.log("BLUUUR");
                        }}

                        validationCallback={res => {

                          this.setState({
                            valorAseguradoValido: !res
                          })

                        }}

                        validationOption={{
                         // name: "Valor Asegurado", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          required: true,
                          type: 'number', // Optional.[String].Default: "string". Validation type, options are ['string', 'number', 'alphanumeric', 'alpha'].
                          min: this.props.limitesVehiculos.limAvaluo.valMin, // Optional.[Number].Default: 0. Validation of min length when validationOption['type'] is string, min amount when validationOption['type'] is number.
                          max: this.props.limitesVehiculos.limAvaluo.valMax,
                          msgOnError: `El valor asegurado debe ser entre $${this.props.limitesVehiculos.limAvaluo.valMin} y $${this.props.limitesVehiculos.limAvaluo.valMax}`
                        }}
                      /> */}
                    </Col>
                  </Row>
{(this.state.codigoProductoEspecial === 'comparador' || this.state.codigoProductoEspecial === 'pits') && (
                    <Row>
                      <Col lg={3} md={6} sm={6} xs={12}>
                        <h5 style={{ fontWeight: "bold" }}>Tipo de Combustible</h5>
                      </Col>
                        <Col lg={4} md={6} sm={6} xs={12}>
                        <Select1
                          tabIndex="6"
                          id={"selectTipoCombustible"}
                          name={"selectTipoCombustible"}
                          value={this.state.tipoCombustible}
                          optionList={
                            this.state.tipoCombustible !== ""
                              ? (this.props.tipoCombustibles || []).filter(c => c.id === this.state.tipoCombustible)
                              : (this.props.tipoCombustibles || [])
                          }
                          disabled={this.state.tipoCombustible !== ""}
                          onChange={(tipoCombustible, e) => {
                            const esAigAutoOPrac = this.state.codigoProductoEspecial === 'comparador' || this.state.codigoProductoEspecial === 'pits';
                            const hasError = esAigAutoOPrac && !tipoCombustible;
                            this.setState({
                              tipoCombustible,
                              formEditado: true,
                              hasTipoCombustibleError: hasError
                            });
                          }}
                          validate={validate}
                          validationCallback={(res) =>
                            this.setState({
                              hasTipoCombustibleError: res,
                              validate: !res,
                            })
                          }
                          validationOption={{
                            name: "selectTipoCombustible",
                            check: true,
                            required: true,
                            msgOnError: "Por favor seleccione el tipo de combustible",
                          }}
                        />
                      </Col>
                    </Row>
                    )}
                  {
                    datosCotizacion.datosPlaca.placa == "" &&
                    <Row>
                      <Col lg={3} md={6} sm={6} xs={12}>
                        <h5 style={{ fontWeight: "bold" }}>Placa</h5>
                      </Col>
                      <Col lg={3} md={6} sm={6} xs={12}>
                        {datosCotizacion.datosPlaca.placa !== "" &&
                          <Textbox
                            ref={this.textInput}
                            tabIndex="1"
                            type="text"
                            id="test"
                            name="test"
                            classNameInput={
                              datosCotizacion.datosPlaca.placa === ""
                                ? "form-control"
                                : "input-type-label form-control"
                            }
                            value={placa}
                          />
                        }

                        {datosCotizacion.datosPlaca.placa === "" &&
                          <Button
                            className="btn btn-purple"
                            onClick={this.onEditarPlaca}
                            style={{ display: "block", margin: "0 0 0 auto" }}
                          >
                            <i className="fa fa-plus-circle" aria-hidden="true" /> INGRESAR PLACA
                          </Button>

                        }
                      </Col>
                    </Row>
                  }

                  <Row>
                    <Col lg={3} md={6} sm={6} xs={12}>
                      <h5 style={{ fontWeight: "bold" }}>Motor</h5>
                    </Col>
                    <Col lg={9} md={6} sm={6} xs={12}>
                      <Textbox
                        tabIndex="1"
                        type="text"
                        id="motor"
                        name="motor"
                        classNameInput={
                          editarMotor
                            ? "form-control"
                            : "input-type-label form-control"
                        }
                        value={motor}
                        onChange={(motor, e) => {
                          this.setState({ motor: motor.toUpperCase(), formEditado: true });
                          this.validarMotor(motor)
                        }}
                        placeholder="Ingrese la serie del motor"
                        validate={validate}
                        validationCallback={(res) => {
                          this.validarMotor(motor)
                          this.setState({
                            hasMotorError: res,
                            validate: false,
                          })
                        }
                        } // Optional.[Func].Default: none. Return the validation result.
                        validationOption={{
                          name: "motor", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          required: false,
                          msgOnError: `Formato de motor no válido`,
                          customFunc: (res) => {
                            return this.state.motorValido
                          },

                        }}
                        onBlur={(e) => {
                          this.setState({ blur: true });
                          //console.log("BLUUUR");
                        }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={3} md={6} sm={6} xs={12}>
                      <h5 style={{ fontWeight: "bold" }}>Chasis</h5>
                    </Col>
                    <Col lg={9} md={6} sm={6} xs={12}>
                      <Textbox
                        tabIndex="1"
                        type="text"
                        id="chasis"
                        name="chasis"
                        classNameInput={
                          editarChasis === true
                            ? "form-control"
                            : "input-type-label form-control"
                        }
                        value={chasis}
                        placeholder="Ingrese la serie del chasis"
                        onChange={(chasis, e) => {
                          this.setState({ chasis: chasis.toUpperCase(), formEditado: true });
                          this.validarChasis(chasis)

                        }}

                        validate={validate}
                        validationCallback={(res) => {
                          this.validarChasis(chasis)
                          //  this.validarChasis(res)
                          this.setState({
                            hasChasisError: res,
                            validate: false,
                          })
                        }
                        } // Optional.[Func].Default: none. Return the validation result.
                        validationOption={{
                          name: "chasis", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                          // check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          required: false,
                          msgOnError: `Formato de chasis no válido`,
                          // Optional.[Bool].Default: true. To determin if it is a required field.
                          //min: this.props.limitesVehiculos.limChasis.valMin,
                          //max: this.props.limitesVehiculos.limChasis.valMax,
                          customFunc: (res) => {


                            return this.state.chasisValido



                          },


                        }}

                        onBlur={(e) => {
                          this.setState({ blur: true });
                        }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={3} md={6} sm={6} xs={12}>
                      <h5 style={{ fontWeight: "bold" }}>Color</h5>
                    </Col>
                    <Col lg={4} md={6} sm={6} xs={12}>
                      <Select
                        //value={selectedOptionColores}
                        value={arrayColores[posicioncolor]}
                        //components={makeAnimated()}
                        onChange={this.handleChangeColores}
                        options={arrayColores}
                        isSearchable={true}
                        placeholder={"Seleccione el color de su vehiculo."}
                        isMulti={false}
                      />
                      {hasColorError && (
                        <span style={{ color: "red", fontSize: "1rem" }}>
                          Por favor seleccione el color de su vehiculo.
                        </span>
                      )}
                    </Col>
                  </Row>

                  <Row>
                    <Col lg={3} md={6} sm={6} xs={12}>
                      <h5 style={{ fontWeight: "bold" }}>Nro. de Ocupantes</h5>
                    </Col>
                    <Col lg={4} md={6} sm={6} xs={12}>
                      <Textbox
                        tabIndex="1"
                        type="text"
                        id="capacidad"
                        name="capacidad"
                        classNameInput={
                          datosCotizacion.datosPlaca.capacidad === ""
                            ? "form-control"
                            : "input-type-label form-control"
                        }
                        value={capacidad}
                        onChange={(capacidad, e) => {
                          this.setState({ capacidad: capacidad });
                        }}
                        placeholder="Ingrese el número de ocupantes del vehículo."
                        validate={validate}
                        validationCallback={(res) =>
                          //console.log(res)
                          this.setState({
                            hasCapacidadError: res,
                            validate: false,
                          })
                        } // Optional.[Func].Default: none. Return the validation result.
                        onBlur={(e) => {
                          this.setState({ blur: true });
                          //console.log("BLUUUR");
                        }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                        validationOption={{
                          name: "capacidad", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          required: true,
                          reg: /^(\d+(?:[\.]\d{2})?)$/, //Optional.[Bool].Default: "" Custom regex.
                          msgOnError:
                            "El número de ocupantes del vehículo debe ser un valor numérico.", // Optional.[Bool].Default: true. To determin if it is a required field.
                        }}
                      />
                    </Col>
                  </Row>
                  {verDeducibles && (
                    <>
                    <Row>
                      <Col lg={3} md={6} sm={6} xs={12}>
                        <h5 style={{ fontWeight: "bold" }}>Deducible para pérdida parcial por daños</h5>
                      </Col>
                      <Col lg={4} md={6} sm={6} xs={12}>
                        <Select1
                          id={"selectDeducibles"} // Optional.[String].Default: "". Input ID.
                          name={"selectDeducibles"} // Optional.[String].Default: "". Input name.
                          //value={datosCotizacion.datosPlaca.tipo!=="" ? datosCotizacion.datosPlaca.tipo :tipoSeleccionado} // Optional.[String].Default: "".
                          value={deducibleSelected} // Optional.[String].Default: "".
                          optionList={arrayDeducibles} // Required.[Array of Object(s)].Default: [].
                          onChange={(deducibleSelected, e) => {
                            this.setState({
                              deducibleSelected,
                              formEditado: true,
                            });
                            //console.log("deducibleSelected", deducibleSelected);
                          }} // Optional.[Func].Default: () => {}. Will return the value.
                          validate={validate}
                          validationCallback={(res) =>
                            //console.log(res)
                            this.setState({
                              hasTipoError: res,
                              validate: false,
                            })
                          }
                          classNameContainer="" //Optional.[String].Default: "".
                          onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                          customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                          validationOption={{
                            name: "selectdeducibles", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                            msgOnError: "Por favor seleccione un deducible",
                          }}
                        />
                      </Col>
                    </Row>
                {/*     <Row style={{ marginTop: "10px" }}>
                      <Col lg={3} md={6} sm={6} xs={12}>
                        <h5 style={{ fontWeight: "bold" }}>Deducible para pérdida total por daños</h5>
                      </Col>
                      <Col lg={4} md={6} sm={6} xs={12}>
                        <Select1
                          id={"selectDeduciblesTotalDanio"}
                          name={"selectDeduciblesTotalDanio"}
                          value={deducibleTotalDanioSelected}
                          optionList={arrayDeduciblesTotalDanio}
                          onChange={(deducibleTotalDanioSelected) => {
                            this.setState({
                              deducibleTotalDanioSelected,
                              formEditado: true,
                            });
                          }}
                          validate={validate}
                          validationCallback={(res) =>
                            this.setState({
                              hasTipoError: res,
                              validate: false,
                            })
                          }
                          classNameContainer=""
                          onBlur={() => { }}
                          customStyleOptionListContainer={{}}
                          validationOption={{
                            name: "selectdeduciblestotaldanio",
                            check: true,
                            required: true,
                            msgOnError: "Por favor seleccione un deducible para pérdida total por daños",
                          }}
                        />
                      </Col>
                    </Row>
                    <Row style={{ marginTop: "10px" }}>
                      <Col lg={3} md={6} sm={6} xs={12}>
                        <h5 style={{ fontWeight: "bold" }}>Deducible para pérdida total por robo</h5>
                      </Col>
                      <Col lg={4} md={6} sm={6} xs={12}>
                        <Select1
                          id={"selectDeduciblesTotalRobo"}
                          name={"selectDeduciblesTotalRobo"}
                          value={deducibleTotalRoboSelected}
                          optionList={arrayDeduciblesTotalRobo}
                          onChange={(deducibleTotalRoboSelected) => {
                            this.setState({
                              deducibleTotalRoboSelected,
                              formEditado: true,
                            });
                          }}
                          validate={validate}
                          validationCallback={(res) =>
                            this.setState({
                              hasTipoError: res,
                              validate: false,
                            })
                          }
                          classNameContainer=""
                          onBlur={() => { }}
                          customStyleOptionListContainer={{}}
                          validationOption={{
                            name: "selectdeduciblestotalrobo",
                            check: true,
                            required: true,
                            msgOnError: "Por favor seleccione un deducible para pérdida total por robo",
                          }}
                        />
                      </Col>
                    </Row> */}
                    </>
                  )}

                  {verRc && (
                    <Row>
                      <Col lg={3} md={6} sm={6} xs={12}>
                        <h5 style={{ fontWeight: "bold" }}>Resp Civil</h5>
                      </Col>
                      <Col lg={4} md={6} sm={6} xs={12}>
                        <Select1
                          id={"selectRc"} // Optional.[String].Default: "". Input ID.
                          name={"selectRc"} // Optional.[String].Default: "". Input name.
                          //value={datosCotizacion.datosPlaca.tipo!=="" ? datosCotizacion.datosPlaca.tipo :tipoSeleccionado} // Optional.[String].Default: "".
                          value={rcSelected} // Optional.[String].Default: "".
                          optionList={arrayRc} // Required.[Array of Object(s)].Default: [].
                          onChange={(rcSelected, e) => {
                            this.setState({ rcSelected, formEditado: true });
                            //console.log("rcSelected", rcSelected);
                          }} // Optional.[Func].Default: () => {}. Will return the value.
                          validate={validate}
                          validationCallback={(res) =>
                            //console.log(res)
                            this.setState({
                              hasTipoError: res,
                              validate: false,
                            })
                          }
                          classNameContainer="" //Optional.[String].Default: "".
                          onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                          customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                          validationOption={{
                            name: "selectRC", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                            msgOnError:
                              "Por favor seleccione una responsabilidad Civil",
                          }}
                        />
                      </Col>
                    </Row>
                  )}

                </CardBody>
              </Card>

              <Card className="flex-row ">
                <CardBody>
                  <h4 style={{ fontWeight: "bold" }}>
                    {" "}
                    Datos del Conductor
                  </h4>
                  <p />
                  {this.props.datosCotizacion.consultarCedulaHasError && (
                    <Alert color="warning">
                      <center>
                        <p>
                          {`No se pudo encontrar información del número de identificación ${cedulaError}. Por favor complete la información manualmente.`}
                        </p>
                      </center>
                    </Alert>
                  )}

                  {mostrarMensajeValidarEdad && (
                    <Alert color="warning">
                      <center>
                        <p>
                          {this.props.dataProductoCarrito.productosCarrito
                            .mensajeValidacionesEdad
                            ? this.props.dataProductoCarrito.productosCarrito
                              .mensajeValidacionesEdad
                            : "El conductor ingresado sobre pasa el rango de edad admitido para cotizar."}
                        </p>
                      </center>
                    </Alert>
                  )}

                  <Row>
                    <Col lg={3} md={4} sm={4} xs={12}>
                      <h5 style={{ fontWeight: "bold" }}>Tipo de documento(*)</h5>
                    </Col>
                    <Col lg={9} md={8} sm={8} xs={12}>
                      <Select1
                        tabIndex="6" // Optional.[String or Number].Default: none.
                        id={"selectMarcas"} // Optional.[String].Default: "". Input ID.
                        name={"selectMarcas"} // Optional.[String].Default: "". Input name.
                        value={this.state.tipoDocumento} // Optional.[String].Default: "".
                        validate={validate}
                        optionList={this.getTipoDocumentos()} // Required.[Array of Object(s)].Default: [].
                        onChange={(tipo, e) => {
                          this.setState({
                            tipoDocumento: tipo,
                            formEditado: true
                          })
                          if (mismosDatos) {
                            this.setState({
                              tipoDocumentoAsegurado: tipo,
                            })
                          }
                          //console.log(e);
                        }} // Optional.[Func].Default: () => {}. Will return the value.
                        onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                        customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                        validationCallback={(res) =>
                          //console.log(res)
                          this.setState({
                            hasCodTipoDocError: res,

                          })
                        }
                        validationOption={{
                          name: "selectMarcas", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                          msgOnError: "Por favor seleccione el tipo de documento",
                        }}
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col lg={3} md={4} sm={4} xs={12}>
                      <h5 style={{ fontWeight: "bold" }}>Cédula</h5>
                    </Col>

                    <Col lg={9} md={8} sm={8} xs={12}>
                      <Textbox
                        maxlength="10"
                        tabIndex="1"
                        type="text"
                        id="cedula"
                        length={this.state.tipoDocumento == 1 ? 10 : null}
                        name="cedula"
                        classNameInput={"form-control"}
                        placeholder="Ingrese la cédula del conductor"
                        value={ValueCedula}
                        validate={validate} //Agregado para validaciones de nombre
                        onBlur={(e) => { }}
                        validationCallback={(res) =>
                          this.setState({ validate: false })
                        } // Optional.[Func].Default: none. Return the validation result.
                        onChange={(cedula, e) => {
                          this.setState({ cedula: cedula });
                          this.props.limpiarDatosCotizacion();

                          if (mismosDatos) {
                            this.setState({
                              cedulaAsegurado: cedula
                            })
                          }
                          if (cedula.length === 10 && this.state.tipoDocumento == 1) {
                            this.cambiarValores(cedula);
                          }
                          //this.props.limpiarDatos();
                          //handleChangeCorreo(e)
                        }}
                        validationOption={{
                          name: "cedula", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          required: true,
                          type: this.state.tipoDocumento == 1 ? 'number' : 'string',
                          minLength: this.state.tipoDocumento == 1 ? 1 : 1,
                          maxLength: this.state.tipoDocumento == 1 ? 10 : 50,
                          length: this.state.tipoDocumento == 1 ? 10 : null,
                          msgOnError: "Por favor ingrese un número de identificación válido", // Optional.[Bool].Default: true. To determin if it is a required field.
                        }}
                      />
                    </Col>
                  </Row>

                  {this.state.tipoDocumento == '3' && (
                    <div>
                      <Row>
                        <Col lg={3} md={4} sm={4} xs={12}>
                          <h5 style={{ fontWeight: "bold" }}>Fecha Expedición Pasaporte (*)</h5>
                        </Col>
                        <Col lg={9} md={8} sm={8} xs={12}>
                          <DatePicker
                            {...this.props}
                            dateFormat="dd/MM/yyyy"
                            selected={this.state.fechaEmisionPasaporte}
                            onChange={(date) => {
                              this.setState((prevState) => ({
                                fechaEmisionPasaporte: date,
                                formEditado: true

                              }))

                              if (mismosDatos) {
                                this.setState({
                                  fechaEmisionPasaporteAsegurado: date,
                                })
                              }
                            }

                            }
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control"
                            placeholderText="Seleccione una fecha"
                            ref={(node) => {
                              this.ref = node;
                            }}
                          />
                          {this.state.fechaEmisionPasaporte == null && (
                            <span
                              style={{
                                display: "block",
                                color: "#ff5a57",
                                fontSize: "1rem",
                                marginLeft: "5px",
                              }}
                            >
                              Por favor ingrese una fecha
                            </span>
                          )}
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={3} md={4} sm={4} xs={12}>
                          <h5 style={{ fontWeight: "bold" }}>Fecha Vencimiento Pasaporte (*)</h5>
                        </Col>
                        <Col lg={9} md={8} sm={8} xs={12}>
                          <DatePicker
                            {...this.props}
                            dateFormat="dd/MM/yyyy"
                            selected={this.state.fechaCaducidadPasaporte}
                            onChange={(date) => {
                              this.setState((prevState) => ({
                                fechaCaducidadPasaporte: date,
                                formEditado: true
                              }))

                              if (mismosDatos) {
                                this.setState({
                                  fechaCaducidadPasaporteAsegurado: date,
                                })
                              }
                            }
                            }
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control"
                            placeholderText="Seleccione una fecha"
                            ref={(node) => {
                              this.ref = node;
                            }}
                          />
                          {this.state.fechaCaducidadPasaporte == null && (
                            <span
                              style={{
                                display: "block",
                                color: "#ff5a57",
                                fontSize: "1rem",
                                marginLeft: "5px",
                              }}
                            >
                              Por favor ingrese una fecha
                            </span>
                          )}
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={3} md={4} sm={4} xs={12}>
                          <h5 style={{ fontWeight: "bold" }}>Fecha Ingreso al País (*)</h5>
                        </Col>
                        <Col lg={9} md={8} sm={8} xs={12}>
                          <DatePicker
                            {...this.props}
                            dateFormat="dd/MM/yyyy"
                            selected={this.state.fechaIngresoPais}
                            onChange={(date) => {
                              this.setState((prevState) => ({
                                fechaIngresoPais: date,
                                formEditado: true
                              }))
                              if (mismosDatos) {
                                this.setState({
                                  fechaIngresoPaisAsegurado: date,
                                })
                              }
                            }
                            }
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control"
                            placeholderText="Seleccione una fecha"
                            ref={(node) => {
                              this.ref = node;
                            }}
                          />
                          {this.state.fechaIngresoPais == null && (
                            <span
                              style={{
                                display: "block",
                                color: "#ff5a57",
                                fontSize: "1rem",
                                marginLeft: "5px",
                              }}
                            >
                              Por favor ingrese una fecha
                            </span>
                          )}
                        </Col>
                      </Row>
                    </div>
                  )}
                  <Row>
                    <Col lg={3} md={4} sm={4} xs={12}>
                      <h5 style={{ fontWeight: "bold" }}>Nombre</h5>
                    </Col>
                    <Col lg={9} md={8} sm={8} xs={12}>
                      <Textbox
                        tabIndex="1"
                        type="text"
                        id="nombre"
                        name="nombre"
                        placeholder="Ingrese los nombres completos"
                        classNameInput={
                          datosCotizacion.datosPersona.nombre === "" ||
                            this.props.datosCotizacion.consultarCedulaHasError ||
                            datosCotizacion.datosPersona.nombre === undefined
                            ? "form-control"
                            : "form-control"
                        }
                        value={nombre}
                        validate={validate} //Agregado para validaciones de nombre
                        onChange={(valor, e) => {
                          this.setState({
                            nombre: valor.toUpperCase(),
                            formEditado: true,
                          });

                          if (mismosDatos) {
                            this.setState({
                              nombreAsegurado: valor.toUpperCase(),
                            })
                          }
                        }}
                        onBlur={(e) => { }}
                        validationCallback={(res) =>
                          this.setState({ validate: false })
                        } // Optional.[Func].Default: none. Return the validation result.
                        validationOption={{
                          name: "nombres", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          required: true,
                          msgOnError:
                            "Ingrese los nombres completos para continuar", // Optional.[Bool].Default: true. To determin if it is a required field.
                        }}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={3} md={4} sm={4} xs={12}>
                      <h5 style={{ fontWeight: "bold" }}>
                        Fecha de Nacimiento
                      </h5>
                    </Col>
                    <Col lg={9} md={4} sm={4} xs={12}
                      style={{ opacity: this.state.mismosDatosConductor && fechaNacimientoArray && (!this.props.datosCotizacion.consultarCedulaHasError) ? 0.6 : 1 }}>
                      <DatePicker
                        {...this.props}
                        dateFormat="dd/MM/yyyy"
                        // isClearable={false}
                        selected={new Date(fechaNacimientoArray)}
                        onChange={(date, e) => {
                          //if(date && date.getDate() && date.getMonth() && date.getFullYear())
                          if (date) {
                            let uno = date.getDate();
                            let dos = date.getMonth() + 1;
                            let tres = date.getFullYear();
                            let fechaaux = uno + "/" + dos + "/" + tres;
                            this.setState({
                              fechaNacimiento: fechaaux,
                              formEditado: true,
                              mostrarMensajeValidarEdad: false,
                            });
                            if (mismosDatos) {
                              this.setState({
                                fechaNacimientoAsegurado: fechaaux,
                              })
                            }
                          } else {
                            this.setState({
                              fechaNacimiento: new Date().toString(
                                "dd/MM/yyyy"
                              ),
                              formEditado: true,
                              mostrarMensajeValidarEdad: false,
                            });

                            if (mismosDatos) {
                              this.setState({
                                fechaNacimientoAsegurado: new Date().toString(
                                  "dd/MM/yyyy"
                                ),
                              })
                            }
                          }
                        }}
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        className={"form-control"}
                        ref={(node) => {
                          this.ref = node;
                        }}
                        disabled={this.state.mismosDatosConductor && fechaNacimientoArray && (!this.props.datosCotizacion.consultarCedulaHasError)}
                      />

                      {/* <Textbox
                        ref={this.textInput}
                        tabIndex="1"
                        type="text"
                        id="test"
                        name="test"
                        classNameInput={
                          datosCotizacion.datosPersona.fechaNacimiento === ""
                            ? "form-control"
                            : "input-type-label form-control"
                        }
                        value={fechaNacimiento}

                      /> */}
                    </Col>
                  </Row>

                  {
                    (!this.state.cargarParentescos) &&
                    <Row>
                      <Col lg={3} md={4} sm={4} xs={12}>
                        <h5 style={{ fontWeight: "bold" }}>Parentesco con el asegurado</h5>
                      </Col>
                      <Col lg={9} md={4} sm={4} xs={12}>
                        <Select1
                          id={"selectEciviles"} // Optional.[String].Default: "". Input ID.
                          name={"selectEciviles"} // Optional.[String].Default: "". Input name.
                          value={parentesco} // Optional.[String].Default: "".
                          optionList={
                            this.props.catalogoCotizacion.parentescos
                          } // Required.[Array of Object(s)].Default: [].
                          onChange={(parentesco, e) => {
                            this.setState({
                              parentesco: parentesco,
                              formEditado: true,
                            });
                            //console.log("estado", estado);
                          }} // Optional.[Func].Default: () => {}. Will return the value.
                          validate={validate}
                          validationCallback={(res) =>
                            this.setState({ validate: res })
                          }
                          // classNameWrapper="bloquear-eventos-mouse"
                          // classNameContainer="input-type-label padding-select-reactinputs" //Optional.[String].Default: "".
                          onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                          customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                          validationOption={{
                            name: "selectParentesco", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                            msgOnError: "Por favor seleccione el parentesco",
                          }}
                        />

                        {/* <Textbox
        tabIndex="1"
        type="text"
        id="test"
        name="test"
        classNameInput={
          datosCotizacion.datosPersona.estadoCivil === ""
            ? "form-control"
            : "input-type-label form-control"
        }
        value={estadoCivil}

      /> */}
                      </Col>
                    </Row>
                  }


                  <Row>
                    <Col lg={3} md={4} sm={4} xs={12}>
                      <h5 style={{ fontWeight: "bold" }}>Estado Civil</h5>
                    </Col>
                    <Col lg={9} md={4} sm={4} xs={12}
                     style={{ opacity: !this.props.datosCotizacion.consultarCedulaHasError ? 0.6 : 1 }}
                    >
                      <Select1
                        id={"selectEciviles"} // Optional.[String].Default: "". Input ID.
                        name={"selectEciviles"} // Optional.[String].Default: "". Input name.
                        value={estadoCivil} // Optional.[String].Default: "".
                        optionList={
                          this.props.catalogoCotizacion.estadosCiviles
                        } // Required.[Array of Object(s)].Default: [].
                        onChange={(estado, e) => {
                          this.setState({
                            estadoCivil: estado,
                            formEditado: true,
                          });
                          if (mismosDatos) {
                            this.setState({
                              estadoCivilAsegurado: estado,
                            })
                          }
                          //console.log("estado", estado);
                        }} // Optional.[Func].Default: () => {}. Will return the value.
                        validate={validate}
                        validationCallback={(res) =>
                          this.setState({ validate: false })
                        }
                        // classNameWrapper="bloquear-eventos-mouse"
                        // classNameContainer="input-type-label padding-select-reactinputs" //Optional.[String].Default: "".
                        onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                        customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                        validationOption={{
                          name: "selectEciviles", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                          msgOnError: "Por favor seleccione el estado civil",
                        }}
                        disabled={!this.props.datosCotizacion.consultarCedulaHasError}
                      />

                      {/* <Textbox
                        tabIndex="1"
                        type="text"
                        id="test"
                        name="test"
                        classNameInput={
                          datosCotizacion.datosPersona.estadoCivil === ""
                            ? "form-control"
                            : "input-type-label form-control"
                        }
                        value={estadoCivil}

                      /> */}
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={3} md={4} sm={4} xs={12}>
                      <h5 style={{ fontWeight: "bold" }}>Género</h5>
                    </Col>
                    <Col lg={9} md={4} sm={4} xs={12}
                     style={{ opacity:  !this.props.datosCotizacion.consultarCedulaHasError ? 0.6 : 1 }}>
                      <Select1
                        id={"selectGeneros"} // Optional.[String].Default: "". Input ID.
                        name={"selectGeneros"} // Optional.[String].Default: "". Input name.
                        value={genero} // Optional.[String].Default: "".
                        optionList={this.props.catalogoCotizacion.generos} // Required.[Array of Object(s)].Default: [].
                        onChange={(genero, e) => {
                          this.setState({ genero: genero, formEditado: true });

                          if (mismosDatos) {
                            this.setState({
                              generoAsegurado: genero,
                            })
                          }
                          //console.log("estado", estado);
                        }} // Optional.[Func].Default: () => {}. Will return the value.
                        validate={validate}
                        validationCallback={(res) =>
                          this.setState({ validate: false })
                        }
                        // classNameWrapper="bloquear-eventos-mouse"
                        // classNameContainer="input-type-label padding-select-reactinputs" //Optional.[String].Default: "".
                        onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                        customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                        validationOption={{
                          name: "selectGeneros", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                          msgOnError: "Por favor seleccione el estado civil",
                        }}
                        disabled={!this.props.datosCotizacion.consultarCedulaHasError}
                      />

                      {/* <Textbox
                        ref={this.textInput}
                        tabIndex="1"
                        type="text"
                        id="test"
                        name="test"
                        classNameInput={
                          datosCotizacion.datosPersona.genero === ""
                            ? "form-control"
                            : "input-type-label form-control"
                        }
                        value={genero}

                      /> */}
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={3} md={4} sm={4} xs={12}>
                      <h5 style={{ fontWeight: "bold" }}>{(codEspecial !== 'comparador' && codEspecial !== 'pits' && codEspecial !== 'vehiculosKilometrosPaquete' && codEspecial !== 'KilometrosConsumidos') ? "Territorio" : "Provincia de circulación"}</h5>
                    </Col>
                    <Col lg={9} md={4} sm={4} xs={12}>



                      {
                        (codEspecial !== 'comparador' && codEspecial !== 'pits' && codEspecial !== 'vehiculosKilometrosPaquete') ?
                          <Select1
                            tabIndex="6" // Optional.[String or Number].Default: none.
                            id={"selectTerritorios"} // Optional.[String].Default: "". Input ID.
                            name={"selectTerritorios"} // Optional.[String].Default: "". Input name.
                            value={territorioSeleccionado} // Optional.[String].Default: "".
                            optionList={arrayTerritorios} // Required.[Array of Object(s)].Default: [].

                            onChange={(territorioSeleccionado, e) => {
                              this.setState({
                                territorioSeleccionado: territorioSeleccionado,
                                formEditado: true,
                              });
                              this.props.setPorcentajeExtras(
                                territorioSeleccionado,
                                codEspecial == 'comparador' || codEspecial == 'pits' ? true : false
                              );

                              //console.log(e);
                            }} // Optional.[Func].Default: () => {}. Will return the value.
                            onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                            customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                            validationOption={{
                              name: "selectTerritorios", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                              check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                              required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                              msgOnError: "Por favor seleccione un territorio",
                            }}
                          /> :
                          <Select
                            tabIndex="6" // Optional.[String or Number].Default: none.
                            id={"selectTerritorios"} // Optional.[String].Default: "". Input ID.
                            name={"selectTerritorios"} // Optional.[String].Default: "". Input name.
                            isSearchable={true}
                            isDisabled={true}
                            value={territorioSeleccionadoComparador} // Optional.[String].Default: "".
                            options={arrayTerritoriosComparador} // Required.[Array of Object(s)].Default: [].
                            onChange={(territorioSeleccionado, e) => {
                              this.setState({
                                territorioSeleccionadoComparador: territorioSeleccionado,
                                formEditado: true,
                              });
                              this.props.setPorcentajeExtras(
                                territorioSeleccionadoComparador.value,
                                codEspecial == 'comparador' || codEspecial == 'pits' ? true : false
                              );
                              if (mismosDatos) {
                                this.setState({
                                  territorioSeleccionadoComparadorAsegurado: territorioSeleccionado,
                                })
                              }
                       
                              //console.log(e);
                            }} // Optional.[Func].Default: () => {}. Will return the value.
                            onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                            customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                            validationOption={{
                              name: "selectTerritorios", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                              check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                              required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                              msgOnError: "Por favor seleccione un territorio",
                            }}
                          />
                      }


                    </Col>
                  </Row>
                  {
                    (this.state.codigoProductoEspecial == "comparador" ||
                      this.state.codigoProductoEspecial == "pits" ||
                      this.state.codigoProductoEspecial == "vehiculosKilometrosPaquete"
                    )

                    &&
                    <Row>
                      <Col lg={3} md={4} sm={4} xs={12}>
                        <h5 style={{ fontWeight: "bold" }}>Celular (*)</h5>
                      </Col>
                      <Col lg={9} md={4} sm={4} xs={12}>

                        <Textbox
                          maxlength="10"
                          tabIndex="1"
                          type="text"
                          id="celular"
                          name="celular"
                          classNameInput={"form-control"}
                          placeholder="Ingrese el número de celular del conductor"
                          value={this.state.celular}
                          validate={validate} //Agregado para validaciones de nombre
                          onBlur={(e) => { }}
                          validationCallback={(res) =>
                            this.setState({ validate: false })
                          } // Optional.[Func].Default: none. Return the validation result.
                          onChange={(celular, e) => {
                            this.setState({ celular: celular, formEditado: true });

                            if (mismosDatos) {
                              this.setState({
                                celularAsegurado: celular,
                              })
                            }


                            //this.props.limpiarDatos();
                            //handleChangeCorreo(e)
                          }}
                          validationOption={{
                            name: "cedula", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: true,
                            type: 'number',
                            minLength: 7,
                            maxLength: 10,
                            msgOnError: 'Ingrese un número de celular vàlido',
                            customFunc: (res) => {
                              if (res.length < 7) {
                                return `El número de celular debe contener al menos ${7} dígitos`
                              }
                              if (res.length > 10) {
                                return `El número de celular debe contener hasta ${10} dígitos`
                              }
                              return true
                            },

                          }}
                        />


                      </Col>
                    </Row>
                  }



                  <Row>
                    <Col md={12} xs={12}>
                      <Checkbox
                        id={"mismosDatos"} // Optional.[String].Default: "".  Input ID.
                        name={"mismosDatos"} // Optional.[String].Default: "". Input name
                        value={mismosDatos} // Required.[String].Default: "".
                        onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                        checked={mismosDatos} // Required.[Bool].Default: false.
                        labelHtml={
                          <div style={{ paddingTop: "0.5em" }}>
                            <h5>
                              Utilizar los mismos datos para datos del asegurado
                            </h5>
                          </div>
                        }
                        onChange={async (mismosDatos, e) => {
                          this.setState({ mismosDatos, formEditado: true });
                          if (mismosDatos) {
                            this.setState({
                              tipoDocumentoAsegurado: this.state.tipoDocumento,
                              cedulaAsegurado: this.state.cedula,
                              nombreAsegurado: this.state.nombre,
                              fechaNacimientoAsegurado: this.state.fechaNacimiento,
                              estadoCivilAsegurado: this.state.estadoCivil,
                              generoAsegurado: this.state.genero,
                              territorioSeleccionadoComparadorAsegurado: this.state.territorioSeleccionadoComparador,
                              celularAsegurado: this.state.celular,
                              fechaEmisionPasaporteAsegurado: this.state.fechaEmisionPasaporte,
                              fechaCaducidadPasaporteAsegurado: this.state.fechaCaducidadPasaporte,
                              fechaIngresoPaisAsegurado: this.state.fechaIngresoPais,

                            });
                            this.setState({ cargarParentescos: true })
                            await this.props.listarParentescos({ traerParentescoTitular: true });
                            this.setState({ cargarParentescos: false })
                          } else {

                            this.setState({
                              tipoDocumentoAsegurado: this.state.tipoDocumento,
                              cedulaAsegurado: '',
                              nombreAsegurado: '',
                              fechaNacimientoAsegurado: null,
                              estadoCivilAsegurado: null,
                              generoAsegurado: null,
                              territorioSeleccionadoComparadorAsegurado: this.state.territorioSeleccionadoComparador,
                              celularAsegurado: '',
                              fechaEmisionPasaporteAsegurado: null,
                              fechaCaducidadPasaporteAsegurado: null,
                              fechaIngresoPaisAsegurado: null,

                            });

                            this.setState({ cargarParentescos: true })
                            await this.props.listarParentescos({ traerParentescoTitular: false });
                            this.setState({ cargarParentescos: false })
                            if (this.state.parentesco == 0) {
                              this.setState({ parentesco: "" })
                            }

                          }
                        }} // Required.[Func].Default: () => {}. Will return the value.
                        validationOption={{
                          name: "mismosDatos", // Optional.[String].Default: "". To display in the Error message. i.e Please check the .
                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                        }}
                      />
                    </Col>
                  </Row>

                  

                </CardBody>
              </Card>

              


              {/* {!mismosDatos && */}
              {!mismosDatos &&

                <Card className="flex-row ">
                  <CardBody>
                    <h4 style={{ fontWeight: "bold" }}>
                      {" "}
                      Datos del asegurado / propietario del vehículo
                    </h4>
                    <p />
                    {this.props.datosCotizacion.consultarCedulaAseguradoHasError && (
                      <Alert color="warning">
                        <center>
                          <p>
                            {`No se pudo encontrar información del número de identificación ${cedulaError}. Por favor complete la información manualmente.`}
                          </p>
                        </center>
                      </Alert>
                    )}

                    {mostrarMensajeValidarEdadAsegurado && (
                      <Alert color="warning">
                        <center>
                          <p>
                            {this.props.datosCotizacion.datosPersona.validacionesEdad
                              .mensajeValidacionesEdad
                              ? this.props.datosCotizacion.datosPersona.validacionesEdad
                                .mensajeValidacionesEdad
                              : "El asegurado ingresado sobrepasa el rango de edad admitido para cotizar."}
                          </p>
                        </center>
                      </Alert>
                    )}

                    <Row>
                      <Col lg={3} md={4} sm={4} xs={12}>
                        <h5 style={{ fontWeight: "bold" }}>Tipo de documento(*)</h5>
                      </Col>
                      <Col lg={9} md={8} sm={8} xs={12}>
                        <Select1
                          tabIndex="6" // Optional.[String or Number].Default: none.
                          id={"selectMarcas"} // Optional.[String].Default: "". Input ID.
                          name={"selectMarcas"} // Optional.[String].Default: "". Input name.
                          value={this.state.tipoDocumentoAsegurado} // Optional.[String].Default: "".
                          validate={validate}
                          optionList={this.getTipoDocumentosAsegurado()} // Required.[Array of Object(s)].Default: [].
                          onChange={(tipo, e) => {
                            this.setState({
                              tipoDocumentoAsegurado: tipo,
                              formEditado: true
                            })
                            //console.log(e);
                          }} // Optional.[Func].Default: () => {}. Will return the value.
                          onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                          customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                          validationCallback={(res) =>
                            //console.log(res)
                            this.setState({
                              hasCodTipoDocError: res,

                            })
                          }
                          validationOption={{
                            name: "selectMarcas", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                            msgOnError: "Por favor seleccione el tipo de documento",
                          }}
                          disabled={false}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={3} md={4} sm={4} xs={12}>
                        {this.state.tipoDocumentoAsegurado != 2 && <h5 style={{ fontWeight: "bold" }}>Cédula</h5>}
                        {this.state.tipoDocumentoAsegurado == 2 && <h5 style={{ fontWeight: "bold" }}>Ruc</h5>}
                      </Col>

                      <Col lg={9} md={8} sm={8} xs={12}>
                        <Textbox
                          maxlength="10"
                          tabIndex="1"
                          type="text"
                          id="cedula"
                          length={this.state.tipoDocumentoAsegurado == 1 ? 10 : this.state.tipoDocumentoAsegurado == 2 ? 13 : null}
                          name="cedula"
                          classNameInput={"form-control"}
                          placeholder="Ingrese la cédula del asegurado"
                          value={ValueCedulaAsegurado}
                          validate={validateAsegurado} //Agregado para validaciones de nombre
                          onBlur={(e) => { }}
                          validationCallback={(res) =>
                            this.setState({ validateAsegurado: !res })
                          } // Optional.[Func].Default: none. Return the validation result.
                          onChange={(cedula, e) => {
                            this.setState({
                              cedulaAsegurado: cedula,
                              formEditado: true
                            });
                            if (this.state.tipoDocumentoAsegurado == 2) {
                              console.log('entroooooo')
                              this.setState({
                                estadoCivilAsegurado: 1,
                                generoAsegurado: 1,
                              });
                          
                            }
                            this.props.limpiarDatosCotizacion();
                            if (cedula.length === 10 && this.state.tipoDocumentoAsegurado == 1) {
                              this.cambiarValoresAsegurado(cedula);
                            }
                            //this.props.limpiarDatos();
                            //handleChangeCorreo(e)
                          }}
                          validationOption={{
                            name: "cedulaAsegurado", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: true,
                            type: this.state.tipoDocumentoAsegurado == 1 ? 'number' : 'string',
                            minLength: this.state.tipoDocumentoAsegurado == 1 ? 1 : 1,
                            maxLength: this.state.tipoDocumentoAsegurado == 1 ? 10 : 50,
                            length: this.state.tipoDocumentoAsegurado == 1 ? 10 : this.state.tipoDocumentoAsegurado == 2 ? 13 : null,
                            msgOnError: this.state.tipoDocumentoAsegurado == 1 ? "Por favor ingrese un número de identificación válido" : "Por favor ingrese un número de documento válido", // Optional.[Bool].Default: true. To determin if it is a required field.
                          }}
                        />
                      </Col>
                    </Row>
                    {this.state.tipoDocumentoAsegurado == 2 &&
                      <Row>
                        <Col lg={4} md={4} sm={4} xs={12}>
                          <h5 style={{ fontWeight: "bold" }} >Seleccione personería(*)</h5>
                        </Col>
                        <Col lg={8} md={8} sm={8} xs={12}>
                          <Select1
                            tabIndex="6"
                            id={"selectMarcas"}
                            name={"selectMarcas"}
                            value={this.state.personeria} // Debe coincidir con el id de la opción seleccionada.
                            validate={validate}
                            optionList={[
                              { id: 0, name: "Seleccione la personería" },
                              { id: 1, name: "Natural" },
                              { id: 2, name: "Jurídica" },
                            ]}
                            onChange={(personeria, e) => {
                              console.log('personeria seleccionada', personeria, e.target.value);

                              // Actualizamos el estado con el `id` de la opción seleccionada.
                              this.setState({
                                formEditado: true,
                                personeria: personeria, // Ahora asignamos el id de la opción seleccionada
                              });

                              console.log('Personería después de asignar: ', personeria);
                            }}
                            onBlur={() => { }}
                            customStyleOptionListContainer={{}}
                            validationCallback={(res) =>
                              this.setState({
                                hasPersoneriaError: res,
                                validate: false,
                              })
                            }
                            validationOption={{
                              name: "selectMarcas",
                              check: true,
                              required: true,
                              msgOnError: "Por favor seleccione la personería",
                            }}
                          />

                        </Col>
                      </Row>
                    }

                    {this.state.tipoDocumentoAsegurado == '45' && (
                      <div>
                        <Row>
                          <Col lg={3} md={4} sm={4} xs={12}>
                            <h5 style={{ fontWeight: "bold" }}>Fecha Expedición Pasaporte (*)</h5>
                          </Col>
                          <Col lg={9} md={8} sm={8} xs={12}>
                            <DatePicker
                              {...this.props}
                              dateFormat="dd/MM/yyyy"
                              selected={this.state.fechaEmisionPasaporteAsegurado}
                              onChange={(date) =>
                                this.setState((prevState) => ({
                                  fechaEmisionPasaporteAsegurado: date,
                                  formEditado: true

                                }))
                              }
                              peekNextMonth
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              className="form-control"
                              placeholderText="Seleccione una fecha"
                              ref={(node) => {
                                this.ref = node;
                              }}
                            />
                            {this.state.fechaEmisionPasaporteAsegurado == null && (
                              <span
                                style={{
                                  display: "block",
                                  color: "#ff5a57",
                                  fontSize: "1rem",
                                  marginLeft: "5px",
                                }}
                              >
                                Por favor ingrese una fecha
                              </span>
                            )}
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={3} md={4} sm={4} xs={12}>
                            <h5 style={{ fontWeight: "bold" }}>Fecha Vencimiento Pasaporte (*)</h5>
                          </Col>
                          <Col lg={9} md={8} sm={8} xs={12}>
                            <DatePicker
                              {...this.props}
                              dateFormat="dd/MM/yyyy"
                              selected={this.state.fechaCaducidadPasaporteAsegurado}
                              onChange={(date) =>
                                this.setState((prevState) => ({
                                  fechaCaducidadPasaporteAsegurado: date,
                                  formEditado: true
                                }))
                              }
                              peekNextMonth
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              className="form-control"
                              placeholderText="Seleccione una fecha"
                              ref={(node) => {
                                this.ref = node;
                              }}
                            />
                            {this.state.fechaCaducidadPasaporteAsegurado == null && (
                              <span
                                style={{
                                  display: "block",
                                  color: "#ff5a57",
                                  fontSize: "1rem",
                                  marginLeft: "5px",
                                }}
                              >
                                Por favor ingrese una fecha
                              </span>
                            )}
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={3} md={4} sm={4} xs={12}>
                            <h5 style={{ fontWeight: "bold" }}>Fecha Ingreso al País (*)</h5>
                          </Col>
                          <Col lg={9} md={8} sm={8} xs={12}>
                            <DatePicker
                              {...this.props}
                              dateFormat="dd/MM/yyyy"
                              selected={this.state.fechaIngresoPaisAsegurado}
                              onChange={(date) =>
                                this.setState((prevState) => ({
                                  fechaIngresoPaisAsegurado: date,
                                  formEditado: true
                                }))
                              }
                              peekNextMonth
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              className="form-control"
                              placeholderText="Seleccione una fecha"
                              ref={(node) => {
                                this.ref = node;
                              }}
                            />
                            {this.state.fechaIngresoPaisAsegurado == null && (
                              <span
                                style={{
                                  display: "block",
                                  color: "#ff5a57",
                                  fontSize: "1rem",
                                  marginLeft: "5px",
                                }}
                              >
                                Por favor ingrese una fecha
                              </span>
                            )}
                          </Col>
                        </Row>
                      </div>
                    )}
                    <Row>
                      <Col lg={3} md={4} sm={4} xs={12}>
                        {this.state.personeria != 2 && <h5 style={{ fontWeight: "bold" }}>Nombre</h5>}
                        {this.state.personeria == 2 && <h5 style={{ fontWeight: "bold" }}>Razón Social</h5>}
                      </Col>
                      <Col lg={9} md={8} sm={8} xs={12}>
                        <Textbox
                          tabIndex="1"
                          type="text"
                          id="nombre"
                          name="nombre"
                          placeholder="Ingrese los nombres completos"
                          classNameInput={
                            "form-control"
                          }
                          value={nombreAsegurado}
                          validate={this.state.validateAseguradoNombre} //Agregado para validaciones de nombre
                          onChange={(valor, e) => {
                            this.setState({
                              nombreAsegurado: valor.toUpperCase(),
                              formEditado: true,
                            });
                          }}
                          onBlur={(e) => { }}
                          validationCallback={(res) =>
                            this.setState({ validateAseguradoNombre: res })
                          } // Optional.[Func].Default: none. Return the validation result.
                          validationOption={{
                            name: "nombres", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: true,
                            msgOnError:
                              "Ingrese los nombres completos para continuar", // Optional.[Bool].Default: true. To determin if it is a required field.
                          }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={3} md={4} sm={4} xs={12}>
                        {this.state.personeria == 2 && <h5 style={{ fontWeight: "bold" }}>Fecha de Constitución</h5>}
                        {this.state.personeria != 2 && <h5 style={{ fontWeight: "bold" }}>
                          Fecha de Nacimiento
                        </h5>}
                      </Col>
                      <Col lg={9} md={4} sm={4} xs={12}>
                        <DatePicker
                          {...this.props}
                          dateFormat="dd/MM/yyyy"
                          // isClearable={false}
                          selected={new Date(fechaNacimientoAseguradoArray)}
                          onChange={(date, e) => {
                            //if(date && date.getDate() && date.getMonth() && date.getFullYear())
                            if (date) {
                              let uno = date.getDate();
                              let dos = date.getMonth() + 1;
                              let tres = date.getFullYear();
                              let fechaaux = uno + "/" + dos + "/" + tres;
                              this.setState({
                                fechaNacimientoAsegurado: fechaaux,
                                formEditado: true,
                                mostrarMensajeValidarEdadAsegurado: false,
                              });
                            } else {
                              this.setState({
                                fechaNacimientoAsegurado: new Date().toString(
                                  "dd/MM/yyyy"
                                ),
                                formEditado: true,
                                mostrarMensajeValidarEdadAsegurado: false,
                              });
                            }
                          }}
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          className={"form-control"}
                          ref={(node) => {
                            this.ref = node;
                          }}
                        />

                        {/* <Textbox
ref={this.textInput}
tabIndex="1"
type="text"
id="test"
name="test"
classNameInput={
datosCotizacion.datosPersona.fechaNacimiento === ""
? "form-control"
: "input-type-label form-control"
}
value={fechaNacimiento}

/> */}
                      </Col>
                    </Row>
                    {/* {this.state.tipoDocumentoAsegurado == 2 && <Row>
      <Col lg={4} md={4} sm={4} xs={12}>
        <h5>Correo Electrónico (*)</h5>
      </Col>
      <Col lg={8} md={8} sm={8} xs={12}>
        <Textbox
          ref={this.textInput}
          tabIndex="1"
          type="text"
          id="correo"
          name="correo"
          validate={validate}
          classNameInput={"form-control"}
          value={this.state.correoRuc}
          onBlur={(e) => {
            //console.log(e);
          }}
          onChange={(email, e) => {

            this.setState({
              correoRuc: email,
            });
            //console.log(e);
          }}
          validationCallback={(res) =>
            //console.log(res)
            this.setState({
              hasCorreoFError: res,
              validate: false,
            })
          }
          validationOption={{
            name: "correo",
            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
            reg: expresionesRegulares.email,
            msgOnError:
              "Por favor ingrese el correo electrónico en minusculas",
          }}
        />
      </Col>
    </Row>}
    {this.state.tipoDocumentoAsegurado == 2 && <Row>
      <Col lg={4} md={4} sm={4} xs={12}>
        <h5>Dirección (*)</h5>
      </Col>
      <Col lg={8} md={8} sm={8} xs={12}>
        <Textarea
          ref={this.textInput}
          tabIndex="1"
          type="text"
          id="direccion"
          name="direccion"
          validate={validate}
          classNameInput={"form-control"}
          value={this.state.direccion}
          onBlur={(e) => {
            //console.log(e);
          }}
          onChange={(direccion, e) => {
            this.setState({
              direccion,
            });
            //console.log(e);
          }}
          validationCallback={(res) =>
            //console.log(res)
            this.setState({
              hasDireccionFError: res,
              validate: false,
            })
          }
          validationOption={{
            name: "direccion", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
            msgOnError: "Por favor ingrese la dirección",
          }}
        />
      </Col>
    </Row>} */}

                    {this.state.tipoDocumentoAsegurado != 2 && <Row>

                      <Col lg={3} md={4} sm={4} xs={12}>
                        <h5 style={{ fontWeight: "bold" }}>Género</h5>
                      </Col>
                      <Col lg={9} md={4} sm={4} xs={12}>
                        <Select1
                          id={"selectGeneros"} // Optional.[String].Default: "". Input ID.
                          name={"selectGeneros"} // Optional.[String].Default: "". Input name.
                          value={generoAsegurado} // Optional.[String].Default: "".
                          optionList={this.props.catalogoCotizacion.generos} // Required.[Array of Object(s)].Default: [].
                          onChange={(genero, e) => {
                            this.setState({ generoAsegurado: genero, formEditado: true });
                            //console.log("estado", estado);
                          }} // Optional.[Func].Default: () => {}. Will return the value.
                          validate={this.state.validateAseguradoGenero}
                          validationCallback={(res) =>
                            this.setState({ validateAseguradoGenero: res })
                          }
                          // classNameWrapper="bloquear-eventos-mouse"
                          // classNameContainer="input-type-label padding-select-reactinputs" //Optional.[String].Default: "".
                          onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                          customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                          validationOption={{
                            name: "selectGeneros", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                            msgOnError: "Por favor seleccione el estado civil",
                          }}
                        />

                        {/* <Textbox
ref={this.textInput}
tabIndex="1"
type="text"
id="test"
name="test"
classNameInput={
datosCotizacion.datosPersona.genero === ""
? "form-control"
: "input-type-label form-control"
}
value={genero}

/> */}
                      </Col>
                    </Row>}
                    {this.state.tipoDocumentoAsegurado != 2 && <Row>
                      <Col lg={3} md={4} sm={4} xs={12}>
                        <h5 style={{ fontWeight: "bold" }}>Estado Civil</h5>
                      </Col>
                      <Col lg={9} md={4} sm={4} xs={12}>
                        <Select1
                          id={"selectEciviles"} // Optional.[String].Default: "". Input ID.
                          name={"selectEciviles"} // Optional.[String].Default: "". Input name.
                          value={estadoCivilAsegurado} // Optional.[String].Default: "".
                          optionList={
                            this.props.catalogoCotizacion.estadosCiviles
                          } // Required.[Array of Object(s)].Default: [].
                          onChange={(estado, e) => {
                            this.setState({
                              estadoCivilAsegurado: estado,
                              formEditado: true,
                            });

                            //console.log("estado", estado);
                          }} // Optional.[Func].Default: () => {}. Will return the value.
                          validate={validate}
                          validationCallback={(res) =>
                            this.setState({ validateAseguradoEstadoCivil: res })
                          }
                          // classNameWrapper="bloquear-eventos-mouse"
                          // classNameContainer="input-type-label padding-select-reactinputs" //Optional.[String].Default: "".
                          onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                          customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                          validationOption={{
                            name: "selectEciviles", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                            msgOnError: "Por favor seleccione el estado civil",
                          }}
                        />

                        {/* <Textbox
        tabIndex="1"
        type="text"
        id="test"
        name="test"
        classNameInput={
          datosCotizacion.datosPersona.estadoCivil === ""
            ? "form-control"
            : "input-type-label form-control"
        }
        value={estadoCivil}

      /> */}
                      </Col>
                    </Row>}
                    <Row>
                      <Col lg={3} md={4} sm={4} xs={12}>
                        <h5 style={{ fontWeight: "bold" }}>{(codEspecial !== 'comparador' && codEspecial !== 'pits' && codEspecial !== 'vehiculosKilometrosPaquete' && codEspecial !== 'KilometrosConsumidos') ? "Territorio" : "Provincia"}</h5>
                      </Col>
                      <Col lg={9} md={4} sm={4} xs={12}>

                        {
                          (codEspecial !== 'comparador' && codEspecial !== 'pits' && codEspecial !== 'vehiculosKilometrosPaquete' && codEspecial !== 'KilometrosConsumidos')

                            ?
                            <Select1
                              tabIndex="6" // Optional.[String or Number].Default: none.
                              id={"selectTerritorios"} // Optional.[String].Default: "". Input ID.
                              name={"selectTerritorios"} // Optional.[String].Default: "". Input name.
                              value={territorioSeleccionado} // Optional.[String].Default: "".
                              optionList={arrayTerritorios} // Required.[Array of Object(s)].Default: [].
                              onChange={(territorioSeleccionado, e) => {
                                this.setState({
                                  territorioSeleccionado: territorioSeleccionado,
                                  formEditado: true,
                                });
                                this.props.setPorcentajeExtras(
                                  territorioSeleccionado,
                                  codEspecial == 'comparador' || codEspecial == 'pits' ? true : false
                                );

                              }} // Optional.[Func].Default: () => {}. Will return the value.
                              onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                              customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                              validationOption={{
                                name: "selectTerritorios", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                msgOnError: "Por favor seleccione un territorio",
                              }}
                            /> :
                            <Select
                              tabIndex="6" // Optional.[String or Number].Default: none.
                              id={"selectTerritorios"} // Optional.[String].Default: "". Input ID.
                              name={"selectTerritorios"} // Optional.[String].Default: "". Input name.
                              isSearchable={true}
                              value={territorioSeleccionadoComparadorAsegurado} // Optional.[String].Default: "".
                              options={arrayTerritoriosComparador} // Required.[Array of Object(s)].Default: [].
                              onChange={(territorioSeleccionado, e) => {
                                this.setState({
                                  territorioSeleccionadoComparadorAsegurado: territorioSeleccionado,
                                  formEditado: true,
                                });

                                console.log('territorioSeleccionado', territorioSeleccionado);
                                this.listarCiudades(territorioSeleccionado.provCodigoCore, null)


                                //console.log(e);
                              }} // Optional.[Func].Default: () => {}. Will return the value.
                              onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                              customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                              validationOption={{
                                name: "selectTerritorios", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                msgOnError: "Por favor seleccione un territorio",
                              }}
                            />
                        }


                      </Col>
                    </Row>
                    <Row>
                      <Col lg={3} md={4} sm={4} xs={12}>
                        <h5 style={{ fontWeight: "bold" }}>Ciudad</h5>
                      </Col>
                      <Col lg={9} md={4} sm={4} xs={12}>


                        <Select
                          tabIndex="6" // Optional.[String or Number].Default: none.
                          id={"selectTerritorios"} // Optional.[String].Default: "". Input ID.
                          name={"selectTerritorios"} // Optional.[String].Default: "". Input name.
                          isSearchable={true}
                          value={ciudadSeleccionada} // Optional.[String].Default: "".
                          options={ciudades} // Required.[Array of Object(s)].Default: [].
                          onChange={(ciudadSeleccionada, e) => {
                            this.setState({
                              ciudadSeleccionada: ciudadSeleccionada,
                              formEditado: true,
                            });




                            //console.log(e);
                          }} // Optional.[Func].Default: () => {}. Will return the value.
                          onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                          customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                          validationOption={{
                            name: "selectCiudad", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                            msgOnError: "Por favor seleccione una ciudad",
                          }}
                        />



                      </Col>
                    </Row>
                    {
                      (this.state.codigoProductoEspecial == "comparador" ||
                        this.state.codigoProductoEspecial == "pits" ||
                        this.state.codigoProductoEspecial == "vehiculosKilometrosPaquete"
                      )

                      &&
                      <Row>
                        {/* <Col lg={3} md={4} sm={4} xs={12}>
          <h5 style={{ fontWeight: "bold" }}>Celular (*)</h5>
        </Col>
        <Col lg={9} md={4} sm={4} xs={12}>

          <Textbox
            maxlength="10"
            tabIndex="1"
            type="text"
            id="celular"
            name="celular"
            classNameInput={"form-control"}
            placeholder="Ingrese el número de celular del asegurado"
            value={this.state.celularAsegurado}
            validate={this.state.validateAseguradoCelular} //Agregado para validaciones de nombre
            onBlur={(e) => { }}
            validationCallback={(res) => {
              this.setState({ validateAseguradoCelular: false })
            }
            } // Optional.[Func].Default: none. Return the validation result.
            onChange={(celular, e) => {
              this.setState({ celularAsegurado: celular, formEditado: true });


              //this.props.limpiarDatos();
              //handleChangeCorreo(e)
            }}
            validationOption={{
              name: "celularAsegurado", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
              check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
              required: true,
              type: 'number',
              minLength: this.props.limitesVehiculos.limTelefono.valMin,
              maxLength: this.props.limitesVehiculos.limTelefono.valMax,
              msgOnError: 'Ingrese un número de celular vàlido',
              customFunc: (res) => {
                if (res.length < this.props.limitesVehiculos.limTelefono.valMin) {
                  return `El número de celular debe contener al menos ${this.props.limitesVehiculos.limTelefono.valMin} dígitos`
                }
                if (res.length > this.props.limitesVehiculos.limTelefono.valMax) {
                  return `El número de celular debe contener hasta ${this.props.limitesVehiculos.limTelefono.valMax} dígitos`
                }
                return true
              },

            }}
          />


        </Col> */}
                      </Row>
                    }





                  </CardBody>
                </Card>


              }




              {
                (codEspecial !== 'vehiculosKilometrosPaquete' &&
                  codEspecial !== 'comparador' &&
                  codEspecial !== 'pits' &&
                  codEspecial !== 'KilometrosConsumidos')
                && (
                  <Card className="flex-row ">
                    <CardBody>
                      <h4 style={{ fontWeight: "bold" }}>
                        {" "}
                        Coberturas Adicionales
                      </h4>
                      <div>
                        (Si deseas puedes añadir las siguientes coberturas para tu
                        póliza dando click en el botón "Agregar".)
                      </div>
                      <p />
                      <Row>
                        <Col lg={12} md={12} sm={12} xs={12}>
                          <ul class="a-container-gray">
                            {ObtenerAmparoGastosTransporte !== undefined &&
                              ObtenerAmparoGastosTransporte[0] !== undefined &&
                              ObtenerAmparoGastosTransporte[0] !== null && (
                                <li class="a-items">
                                  <input
                                    type="radio"
                                    name="amparogm"
                                    id="amparogm"
                                  />
                                  <label for="amparogm">
                                    {
                                      ObtenerAmparoGastosTransporte[0]
                                        .cobDescripcion
                                    }
                                  </label>
                                  <div class="a-content-gray">
                                    <Row>
                                      <Col lg={9} md={9} sm={8} xs={12}>
                                        <p style={{ textAlign: "justify" }}>
                                          {
                                            ObtenerAmparoGastosTransporte[0]
                                              .cobDetalle
                                          }
                                        </p>
                                      </Col>
                                      <Col lg={3} md={3} sm={4} xs={12}>
                                        <Checkbox
                                          id={"amparoGastosTransporte"} // Optional.[String].Default: "".  Input ID.
                                          name={"amparoGastosTransporte"} // Optional.[String].Default: "". Input name
                                          classNameInputBox={'check-uber'}
                                          checked={amparoGastosTransporteCheked} // Required.[Bool].Default: false.
                                          onChange={(
                                            amparoGastosTransporteCheked,
                                            e
                                          ) => {
                                            this.setState({
                                              amparoGastosTransporteCheked,
                                              formEditado: true,
                                            });
                                            //console.log(e);
                                          }} // Required.[Func].Default: () => {}. Will return the value.
                                          labelHtml={
                                            <div style={{ background: "none" }}>
                                              Agregar
                                            </div>
                                          } // Required.[Html].Default: none.
                                        />
                                      </Col>
                                    </Row>
                                  </div>
                                </li>
                              )}
                            {ObtenerAmparoPatrimonial !== undefined &&
                              ObtenerAmparoPatrimonial[0] !== undefined &&
                              ObtenerAmparoPatrimonial[0] !== null && (
                                <li class="a-items">
                                  <input
                                    type="radio"
                                    name="amparogm"
                                    id="amparogm"
                                  />
                                  <label for="amparogm">
                                    {ObtenerAmparoPatrimonial[0].cobDescripcion}
                                  </label>
                                  <div class="a-content-gray">
                                    <Row>
                                      <Col lg={9} md={9} sm={8} xs={12}>
                                        <p style={{ textAlign: "justify" }}>
                                          {ObtenerAmparoPatrimonial[0].cobDetalle}
                                        </p>
                                      </Col>
                                      <Col lg={3} md={3} sm={4} xs={12}>
                                        <Checkbox
                                          id={"amparoPatrimonial"} // Optional.[String].Default: "".  Input ID.
                                          name={"amparoPatrimonial"} // Optional.[String].Default: "". Input name
                                          checked={amparoPatrimonialCheked} // Required.[Bool].Default: false.
                                          classNameInputBox={'check-uber'}
                                          onChange={(
                                            amparoPatrimonialCheked,
                                            e
                                          ) => {
                                            this.setState({
                                              amparoPatrimonialCheked,
                                              formEditado: true,
                                            });
                                            //console.log(e);
                                          }} // Required.[Func].Default: () => {}. Will return the value.
                                          labelHtml={
                                            <div style={{ background: "none" }}>
                                              Agregar
                                            </div>
                                          } // Required.[Html].Default: none.
                                        />
                                      </Col>
                                    </Row>
                                  </div>
                                </li>
                              )}
                            {ObtenerAmparoObjetosOlvidados !== undefined &&
                              ObtenerAmparoObjetosOlvidados[0] !== undefined &&
                              ObtenerAmparoObjetosOlvidados[0] !== null && (
                                <li class="a-items">
                                  <input
                                    type="radio"
                                    name="amparogm"
                                    id="amparogm"
                                  />
                                  <label for="amparogm">
                                    {
                                      ObtenerAmparoObjetosOlvidados[0]
                                        .cobDescripcion
                                    }
                                  </label>
                                  <div class="a-content-gray">
                                    <Row>
                                      <Col lg={9} md={9} sm={8} xs={12}>
                                        <p style={{ textAlign: "justify" }}>
                                          {
                                            ObtenerAmparoObjetosOlvidados[0]
                                              .cobDetalle
                                          }
                                        </p>
                                      </Col>
                                      <Col lg={3} md={3} sm={4} xs={12}>
                                        <Checkbox
                                          id={"amparoObjetosOlvidados"} // Optional.[String].Default: "".  Input ID.
                                          name={"amparoObjetosOlvidados"} // Optional.[String].Default: "". Input name
                                          classNameInputBox={'check-uber'}
                                          checked={amparoObjetosOlvidadosCheked} // Required.[Bool].Default: false.
                                          onChange={(
                                            amparoObjetosOlvidadosCheked,
                                            e
                                          ) => {
                                            this.setState({
                                              amparoObjetosOlvidadosCheked,
                                              formEditado: true,
                                            });
                                            //console.log(e);
                                          }} // Required.[Func].Default: () => {}. Will return the value.
                                          labelHtml={
                                            <div style={{ background: "none" }}>
                                              Agregar
                                            </div>
                                          } // Required.[Html].Default: none.
                                        />
                                      </Col>
                                    </Row>
                                  </div>
                                </li>
                              )}
                            {ObtenerAmparoGastosFunerarios !== undefined &&
                              ObtenerAmparoGastosFunerarios[0] !== undefined &&
                              ObtenerAmparoGastosFunerarios[0] !== null && (
                                <li class="a-items">
                                  <input
                                    type="radio"
                                    name="amparogm"
                                    id="amparogm"
                                  />
                                  <label for="amparogm">
                                    {
                                      ObtenerAmparoGastosFunerarios[0]
                                        .cobDescripcion
                                    }
                                  </label>
                                  <div class="a-content-gray">
                                    <Row>
                                      <Col lg={9} md={9} sm={8} xs={12}>
                                        <p style={{ textAlign: "justify" }}>
                                          {
                                            ObtenerAmparoGastosFunerarios[0]
                                              .cobDetalle
                                          }
                                        </p>
                                      </Col>
                                      <Col lg={3} md={3} sm={4} xs={12}>
                                        <Checkbox
                                          id={"amparoGastosFunerarios"} // Optional.[String].Default: "".  Input ID.
                                          name={"amparoGastosFunerarios"} // Optional.[String].Default: "". Input name
                                          classNameInputBox={'check-uber'}
                                          checked={amparoGastosFunerariosCheked} // Required.[Bool].Default: false.
                                          onChange={(
                                            amparoGastosFunerariosCheked,
                                            e
                                          ) => {
                                            this.setState({
                                              amparoGastosFunerariosCheked,
                                              formEditado: true,
                                            });
                                            //console.log(e);
                                          }} // Required.[Func].Default: () => {}. Will return the value.
                                          labelHtml={
                                            <div style={{ background: "none" }}>
                                              Agregar
                                            </div>
                                          } // Required.[Html].Default: none.
                                        />
                                      </Col>
                                    </Row>
                                  </div>
                                </li>
                              )}
                          </ul>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>)
              }
              {
                (codEspecial !== 'comparador' && codEspecial !== 'pits') &&

                <Card className="flex-row ">
                  <CardBody>
                    <h4 style={{ fontWeight: "bold" }}> Coberturas</h4>
                    <p />
                    <Row>
                      {Object.keys(datosCoberturas).length > 0 &&
                        datosCoberturas.map((dCob, i) => {
                          return (
                            <Col lg={12} md={12} sm={12} xs={12} className="mb-3">
                              <ul class="a-container">
                                <li class="a-items">
                                  <input type="radio" name="ac" id={"a" + i} />
                                  <label for={"a" + i}>
                                    {dCob.cobDescripcion}
                                  </label>
                                  <div class="a-content">
                                    <p style={{ textAlign: "justify" }}>
                                      {dCob.cobDetalle}
                                    </p>
                                  </div>
                                </li>
                              </ul>
                            </Col>
                          );
                        })}

                      <Col lg={12} md={12} sm={12} xs={12} className="mb-3">
                        {ObtenerAmparoAutoSustituto !== undefined &&
                          ObtenerAmparoAutoSustituto[0] !== undefined &&
                          ObtenerAmparoAutoSustituto[0] !== null && (
                            <ul class="a-container">
                              <li class="a-items">
                                <input type="radio" name="ac" id="aAmpSusti" />
                                <label for="aAmpSusti">
                                  {ObtenerAmparoAutoSustituto[0].cobDescripcion}
                                </label>
                                <div class="a-content">
                                  <p style={{ textAlign: "justify" }}>
                                    {ObtenerAmparoAutoSustituto[0].cobDetalle}
                                  </p>
                                </div>
                              </li>
                            </ul>
                          )}
                      </Col>
                      <Col lg={12} md={12} sm={12} xs={12} className="mb-3">
                        {ObtenerAmparoLlaveProtegida !== undefined &&
                          ObtenerAmparoLlaveProtegida[0] !== undefined &&
                          ObtenerAmparoLlaveProtegida[0] !== null && (
                            <ul class="a-container">
                              <li class="a-items">
                                <input type="radio" name="ac" id="aLlaveProt" />
                                <label for="aLlaveProt">
                                  {ObtenerAmparoLlaveProtegida[0].cobDescripcion}
                                </label>
                                <div class="a-content">
                                  <p style={{ textAlign: "justify" }}>
                                    {ObtenerAmparoLlaveProtegida[0].cobDetalle}
                                  </p>
                                </div>
                              </li>
                            </ul>
                          )}
                      </Col>
                      <Col lg={12} md={12} sm={12} xs={12} className="mb-3">
                        {ObtenerAmparoDocumentosProtegidos !== undefined &&
                          ObtenerAmparoDocumentosProtegidos[0] !== undefined &&
                          ObtenerAmparoDocumentosProtegidos[0] !== null && (
                            <ul class="a-container">
                              <li class="a-items">
                                <input type="radio" name="ac" id="aDocProt" />
                                <label for="aDocProt">
                                  {
                                    ObtenerAmparoDocumentosProtegidos[0]
                                      .cobDescripcion
                                  }
                                </label>
                                <div class="a-content">
                                  <p style={{ textAlign: "justify" }}>
                                    {
                                      ObtenerAmparoDocumentosProtegidos[0]
                                        .cobDetalle
                                    }
                                  </p>
                                </div>
                              </li>
                            </ul>
                          )}
                      </Col>
                      <Col lg={12} md={12} sm={12} xs={12} className="mb-3">
                        {ObtenerAmparoGastosMedicos !== undefined &&
                          ObtenerAmparoGastosMedicos[0] !== undefined &&
                          ObtenerAmparoGastosMedicos[0] !== null && (
                            <ul class="a-container">
                              <li class="a-items">
                                <input type="radio" name="ac" id="aGMedicos" />
                                <label for="aGMedicos">
                                  {ObtenerAmparoGastosMedicos[0].cobDescripcion}
                                </label>
                                <div class="a-content">
                                  <p style={{ textAlign: "justify" }}>
                                    {ObtenerAmparoGastosMedicos[0].cobDetalle}
                                  </p>
                                </div>
                              </li>
                            </ul>
                          )}
                      </Col>
                      <Col lg={12} md={12} sm={12} xs={12} className="mb-3">
                        {ObtenerAmparoAccidentesPersonales !== undefined &&
                          ObtenerAmparoAccidentesPersonales[0] !== undefined &&
                          ObtenerAmparoAccidentesPersonales[0] !== null && (
                            <ul class="a-container">
                              <li class="a-items">
                                <input
                                  type="radio"
                                  name="ac"
                                  id="aAccidentesPersonales"
                                />
                                <label for="aAccidentesPersonales">
                                  {
                                    ObtenerAmparoAccidentesPersonales[0]
                                      .cobDescripcion
                                  }
                                </label>
                                <div class="a-content">
                                  <p style={{ textAlign: "justify" }}>
                                    {
                                      ObtenerAmparoAccidentesPersonales[0]
                                        .cobDetalle
                                    }
                                  </p>
                                </div>
                              </li>
                            </ul>
                          )}
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              }
              {
                ((codEspecial === 'comparador' || codEspecial === 'pits') &&
                  this.state.planesComparador &&
                  this.state.planesComparador.length > 0 &&
                  this.state.planComparadorSeleccionado &&
                  this.state.mostrarTablaCoberturas 
                )

                &&


                <Card>
                  <CardBody>
                    <TablaCoberturasIndividual
                      setPlanSeleccionadoMain={(plan) => {
                        this.setState({ planComparadorSeleccionado: plan, coberturasAdicionalesComparador: [], formEditado: true })
                      }}
                      valorAsegurado={this.state.valorAsegurado}
                      limiteAmparo={this.props.limitesVehiculos.limAmparo}
                      planSeleccionadoMain={this.state.planComparadorSeleccionado}
                      coberturasAdicionalesComparador={this.state.coberturasAdicionalesComparador}
                      coberturasSeleccionadas={this.props.datosCotizacion.datosPersona.amparosAux}
                      codigoProductoEspecial={codEspecial}

                      setCoberturasAdicionalesComparador={(adicionales, actualizar) => {

                        console.log('adicionales', adicionales)


                        this.setState({
                          coberturasAdicionalesComparador: adicionales,
                          formEditado: actualizar
                        })
                      }}


                      planesComparador={this.state.planesComparador.sort(function (a, b) {
                        if (a.primaTotal < b.primaTotal) return 1;
                        if (b.primaTotal < a.primaTotal) return -1;
                        return 0;
                      })}
                    >

                    </TablaCoberturasIndividual>

                  </CardBody>
                </Card>



              }

            </Col>

            <Col
              lg={4}
              md={12}
              sm={12}
              xs={12}
              className="detalle-impuestos-box"
            >



              {/*        {
                (codEspecial === 'comparador' &&
                  this.state.planComparadorSeleccionado &&
                  this.state.planesComparador &&
                  this.state.planesComparador.length > 0) &&
                <ValoresCotizacionComparador
                  planSeleccionado={this.state.planComparadorSeleccionado}
                  formEditado={formEditado}

                  metodo={() => {
                    console.log('aqui estoy')
                    this.onClick()
                  }}
                >

                </ValoresCotizacionComparador>
              } */}





              <ValoresCotizacion
                key={1}
                formEditado={formEditado}
                paso={"datos-cotizacion"}
                metodo={this.onClick}
                placa={placa}
                planes={this.state.planes}
                planSeleccionado={codEspecial == 'comparador' || codEspecial == 'pits' ? this.state.planComparadorSeleccionado : this.state.planSeleccionado}
                codigoProductoEspecial={
                  this.state.codigoProductoEspecial != null ? true : false
                }
                codeProductoEspecial={this.state.codigoProductoEspecial}
                onSelect={this.onSelect}
                errorProducto={this.state.errorProducto }
                mensajeErrorProducto={this.state.mensajeErrorProducto}
              />
            
            </Col>
          </Row >
        </Page >

        <div>
          <Modal
            isOpen={this.state.openModal}
            toggle={() => this.openModal(false)}
          >
            <ModalHeader toggle={() => this.openModal(false)}>
              {this.state.planSeleccionado != null
                ? this.state.planSeleccionado.descripcion
                : ""}
            </ModalHeader>
            <ModalBody>
              <div className="row">
                <div className="col">
                  <label>
                    <strong>Code: </strong>
                  </label>
                  <br />
                  <label>
                    <strong>Value1: </strong>
                  </label>
                </div>
                <div className="col">
                  <label>
                    {this.state.planSeleccionado != null
                      ? this.state.planSeleccionado.code
                      : ""}
                  </label>
                  <br />
                  <label>
                    {this.state.planSeleccionado != null
                      ? this.state.planSeleccionado.value1
                      : ""}
                  </label>
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={() => this.openModal(false)}>
                Cerrar
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      </LoadingScreen >
    );
  }
}

const mapStateToProps = (state) => ({
  //userIsLoggedIn: state.datosUsuarios.dataUsuario.userIsLoggedIn,
  datosCotizacion: state.datosCotizacion,
  productosCarrito: state.productosCarrito,
  catalogoCotizacion: state.catalogosCotizacion,
  tipoCombustibles: state.catalogosCotizacion.tipoCombustibles,
  dataProductoCarrito: state.dataProductoCarrito,
  datosUsuarios: state.datosUsuarios.dataUsuario,
  datosSucursales: state.datosSucursales,
  datosCoberturas: state.catalogosCotizacion.coberturas,
  datosAmparos: state.catalogosCotizacion.amparosAdicionales,
  deduciblesRolesDatos: state.deduciblesRolesDatos,
  dataFacturacion: state.dataFacturacion.datosFacturacion,
  limitesVehiculos: state.dataParametros,
  planesComparador: state.dataPlanesComparador.planesComparador,
  provinciasComparador: state.dataTerritoriosComparador.territorios.provincias,
  provinciaComparadorDefault: parseInt(state.dataTerritoriosComparador.territorios.provinciaDefecto)
});

const mapDispatchToProps = (dispatch) => {
  return {
    consultarCedula: (cedula, esAsegurado, esContratante) => dispatch(consultarCedulaFetch(cedula, esAsegurado, esContratante)),
    setDatosPlaca: (datos) => dispatch(setConsultaPlaca(datos)),
    listarParentescos: (datos) => dispatch(listarParentescosFetch(datos)),
    modificarCarrito: (datos) => dispatch(FetchModificarCarrito(datos)),
    setDatosPersona: (datos) => dispatch(setDatosPersona(datos)),
    setDatosPersonaAsegurado: (datos) => dispatch(setDatosPersonaAsegurado(datos)),
    limpiarDatosCotizacion: () => dispatch(limpiarDatosCotizacion2()),
    fetchGuardarDatosAdiconalesCarrito: (datos, array) =>
      dispatch(FetchGuardarDatosAdiconalesCarrito(datos, array)),
    listarCoberturas: (territorio) => dispatch(coberturasFetch(territorio)),
    listarAmparosAdicionales: (territorio, codEspecial) =>
      dispatch(AmparosAdicionalesFetch(territorio, codEspecial)),
    setPorcentajeExtras: (zona, esComparador) => dispatch(FetchPorcentajeExtras(zona, esComparador)),
    datosFacturacion: (data) => dispatch(recuperarDatosFacturacionFetch(data)),
    actualizarTotalesCabecera: (param) =>
      dispatch(FetchTotalesCabeceraCotizadores(param)),
    consultarProvincias: (ramo, sucursal) => dispatch(listarProvinciasComparadorFetch(ramo, sucursal)),
    listarTipoCombustibles: () => dispatch(listarTipoCombustibleFetch()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Cotizacion2)
);
